import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import ReactDOM from 'react-dom';
import { Select, Button, Group, Text, Accordion, Checkbox, Input, Tabs, Table, MultiSelect, LoadingOverlay, ActionIcon, TextInput, PasswordInput, Divider } from '@mantine/core';
import { IconCheck, IconCircleMinus, IconPlus, IconHelp, IconX } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { SelectTooltip } from "../../components/GeneralComponent/GeneralComponent";
import CampaignApi from "../../api/CampaignApi";
import classes from '../../pages/DashBoard/DashBoard.module.css';
import { modals } from '@mantine/modals';

export function Step5({ selectedMemberWebsite, campaign_id, campaignId, glConvCustomerId, glConvSubCustomerId, tbAdAccountId, step5Disabled, 
                        campaignLoader, setStep5Show, step5Show, convAttributionModel, handleConvAttributionModelChange, sendAllConversionFb, isFacebookChecked,
                        isGoogleChecked, isMicrosoftChecked, isTiktokChecked, isTaboolaChecked, isOutbrainChecked, isLinkedInChecked, obConvadaccountid, msConvadaccountid, conversionApiType,
                        tkUserAccesstoken, tkConvAdAccountId, glUserRefreshtoken, tbUserRefreshtoken, obUsertoken, msUserRefreshtoken,lnadaccountid,lnAccesstoken, isChatgptChecked
                      }:any) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Facebook');
  const [tabLoader, settabLoader] = useState(false);

  const step5IconRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const [isFbSendAllConversionChecked, setIsFbSendAllConversionChecked] = useState(sendAllConversionFb === true);
  const [fbConvMessageRow, setFbConvMessageRow] = useState([]);
  const [fbConversionGoal, setFbConversionGoal] = useState([]);
  const [fbConversionEvent, setFbConversionEvent] = useState([]);
  const [fbConversionCurrency, setFbConversionCurrency] = useState([]);
  const [fbPixelIdValue, setFbPixelIdValue] = useState({});
  const [fbAccessTokenValue, setFbAccessTokenValue] = useState({});
  const [fbAccountIdValue] = useState({});
  const [fbTotalRowShow, setFbTotalRowShow] = useState(0);

  const [fbConversionEventMP, setFbConversionEventMP] = useState([]);
  const [fbConversionEventValueMP, setFbConversionEventValueMP] = useState('');
  const [fbConversionCurrencyMP, setFbConversionCurrencyMP] = useState([]);
  const [fbConversionCurrencyValueMP, setFbConversionCurrencyValueMP] = useState('');
  const [facebookConversionPageview, setFacebookConversionPageview] = useState(false);
  const [goalGroups, setGoalGroups] = useState([]);
  const [fbAdAccountDetails, setFbAdAccountDetails] = useState([]);

  const [glTotalRowShow, setGlTotalRowShow] = useState(0);
  const [glCustomer, setGlCustomer] = useState([]);
  const [glCustomerValue, setGlCustomerValue] = useState('');
  const [glSubCustomer, setGlSubCustomer] = useState([]);
  const [glSubCustomerValue, setGlSubCustomerValue] = useState('');
  const [glConvMessageRow, setGlConvMessageRow] = useState([]);
  const [glConversionActionMP, setGlConversionActionMP] = useState([]);
  const [useglConversionActionMPData, setUseglConversionActionMPData] = useState(false);
  const [glConvAction, setGlConvAction] = useState([]);
  const [glConvActionValue, setGlConvActionValue] = useState('');
  const [glConvPageDetail, setGlConvPageDetail] = useState([]);
  const [googleConversionPageview, setGoogleConversionPageview] = useState(false);
  const [glgoalGroups, setGlGoalGroups] = useState([]);

  const [tbConvPageDetail, setTbConvPageDetail] = useState([]);
  const [tbConversionAction, setTbConversionAction] = useState([]);
  const [tbConvActionValue, setTbConvActionValue] = useState('');
  const [useTbConversionActionMPData, setUseTbConversionActionMPData] = useState(false);
  const [tbAdAccountDetails, setTbAdAccountDetails] = useState([]);
  const [tbAdAccountDetailsValue, setTbAdAccountDetailsValue] = useState('');
  const [tbgoalGroups, setTbGoalGroups] = useState([]);
  const [tbConvMessageRow, setTbConvMessageRow] = useState([]);
  const [taboolaConversionPageview, setTaboolaConversionPageview] = useState(false);
  const [tbConversionActionMP, setTbConversionActionMP] = useState([]);

  const [tkAdvertiserAccountValue, setTkAdvertiserAccountValue] = useState('');
  const [tiktokConversionPageview, setTiktokConversionPageview] = useState(false);
  const [useTkConversionPixelMPData, setUseTkConversionPixelMPData] = useState(false);
  const [useTkConversionEventMPData, setUseTkConversionEventMPData] = useState(false);
  const [tkConvPageDetail, setTkConvPageDetail] = useState([]);
  const [tkPixelAdAccountDetails, setTkPixelAdAccountDetails] = useState([]);
  const [tkEventNamePageview, setTkEventNamePageview] = useState([]);
  const [tkAdAccountDetails, setTkAdAccountDetails] = useState([]);
  const [tkConversionPixelMP, setTkConversionPixelMP] = useState([]);
  const [tkConvPixelValue, setTkConvPixelValue] = useState('');
  const [tkConversionEventMP, setTkConversionEventMP] = useState([]);
  const [tkConvEventValue, setTkConvEventValue] = useState('');
  const [tkgoalGroups, setTkGoalGroups] = useState([]);
  const [tkConvMessageRow, setTkConvMessageRow] = useState([]);

  const [obAdAccountDetails, setObAdAccountDetails] = useState([]);
  const [obAdAccountDetailsValue, setObAdAccountDetailsValue] = useState('');
  const [obConversionAction, setObConversionAction] = useState([]);
  const [obConvPageDetail, setObConvPageDetail] = useState([]);
  const [obConvMessageRow, setObConvMessageRow] = useState([]);
  const [outbrainConversionPageview, setOutbrainConversionPageview] = useState(false);
  const [obConversionActionMP, setObConversionActionMP] = useState([]);
  const [obConvActionValue, setObConvActionValue] = useState('');
  const [useObConversionActionMPData, setUseObConversionActionMPData] = useState(false);
  const [obgoalGroups, setObGoalGroups] = useState([]);

  const [msAdAccountDetails, setMsAdAccountDetails] = useState([]);
  const [msAdAccountDetailsValue, setMsAdAccountDetailsValue] = useState('');
  const [msConversionAction, setMsConversionAction] = useState([]);
  const [msConvPageDetail, setMsConvPageDetail] = useState([]);
  const [msConvMessageRow, setMsConvMessageRow] = useState([]);
  const [microsoftConversionPageview, setMicrosoftConversionPageview] = useState(false);
  const [msConversionActionMP, setMsConversionActionMP] = useState([]);
  const [msConvActionValue, setMsConvActionValue] = useState('');
  const [useMsConversionActionMPData, setUseMsConversionActionMPData] = useState(false);
  const [msgoalGroups, setMsGoalGroups] = useState([]);

  const [lnConvMessageRow, setLnConvMessageRow] = useState([]);
  const [lnTotalRowShow, setLnTotalRowShow] = useState(0);
  const [linkedinConversionPageview, setLinkedInConversionPageview] = useState(false);
  // const [uselnConversionPageviewData, setUselnConversionPageviewData] = useState(false);
  const [lnConvNameValue, setLnConvNameValue] = useState('');
  const [lnPageviewConvName, setLnPageviewConvName] = useState([]);
  const [lngoalGroups, setLnGoalGroups] = useState([]);
  const [lnConvPageDetail, setLnConvPageDetail] = useState([]);

  // ChatGPT Conversions API state (mirrors Facebook: event + currency mapping)
  const [cgptConvMessageRow, setCgptConvMessageRow] = useState([]);
  const [cgptConversionGoal, setCgptConversionGoal] = useState([]);
  const [cgptConversionEvent, setCgptConversionEvent] = useState([]);
  const [cgptConversionCurrency, setCgptConversionCurrency] = useState([]);
  const [cgptConversionEventMP, setCgptConversionEventMP] = useState([]);
  const [cgptConversionEventValueMP, setCgptConversionEventValueMP] = useState('');
  const [cgptConversionCurrencyMP, setCgptConversionCurrencyMP] = useState([]);
  const [cgptConversionCurrencyValueMP, setCgptConversionCurrencyValueMP] = useState('');
  const [chatgptConversionPageview, setChatgptConversionPageview] = useState(false);
  const [cgptgoalGroups, setCgptGoalGroups] = useState([]);
  const [cgptTotalRowShow, setCgptTotalRowShow] = useState(0);
  const [cgptPixelIdValue, setCgptPixelIdValue] = useState('');
  const [cgptConversionKeyValue, setCgptConversionKeyValue] = useState('');
  const [cgptHasConversionKey, setCgptHasConversionKey] = useState(false);
  const [cgptCredSaving, setCgptCredSaving] = useState(false);
  // Only order_created and subscription_created carry a monetary value per ChatGPT's supported events.
  const cgptCurrencyEvents = ['order_created','subscription_created'];

  const handleFbSendAllConversionChange = (event) => {
    setIsFbSendAllConversionChecked(event.target.checked);
  };

  useEffect(() => {
    setIsFbSendAllConversionChecked(sendAllConversionFb === true);
  }, [sendAllConversionFb]);

  /*start chatgpt step 5*/
  const getchatgptconversionsdata = () => {
    settabLoader(true);
    CampaignApi.getchatgptconversionsdata({
      campaign_id : campaign_id || campaignId
    })
    .then(response => {
      if (response.ok) { return response.json(); }
      else { if (response.status === 401 || response.status === 400) { navigate("/logout"); } }
    })
    .then(data => {
      if(data && data.status === 1){
        setCgptConvMessageRow(data.data.message_row || []);
        setCgptConversionGoal(data.data.cgpt_conversion_goal_event.cgpt_conversion_goal || []);
        setCgptConversionEvent(data.data.cgpt_conversion_goal_event.cgpt_conversion_event || []);
        setCgptConversionCurrency(data.data.cgpt_conversion_goal_event.cgpt_conversion_currency || []);
        if(chatgptConversionPageview !== true){
          setChatgptConversionPageview(data.data.message_pageview.chatgpt_conversion_pageview);
        }
        setCgptConversionEventMP(data.data.message_pageview.cgpt_conversion_event || []);
        setCgptConversionCurrencyMP(data.data.message_pageview.cgpt_conversion_currency || []);
        setCgptPixelIdValue(data.data.cgpt_pixel_id || '');
        setCgptHasConversionKey(data.data.has_conversion_key === 1);
      }
      settabLoader(false);
    })
    .catch(error => { settabLoader(false); console.log(error); });
  };

  useEffect(() => {
    if(setStep5Show !== '0' && activeTab === 'ChatGPT'){ getchatgptconversionsdata(); }
  }, [activeTab,setStep5Show]);

  useEffect(() => {
    setCgptTotalRowShow(cgptgoalGroups.length + cgptConvMessageRow.length);
  }, [cgptgoalGroups,cgptConvMessageRow]);

  const handleChatgptConversionPageviewChange = (event) => { setChatgptConversionPageview(event.target.checked); };
  const handlecgptConversionGoalChange = (value, id) => { setCgptGoalGroups(groups => groups.map(group => group.id === id ? { ...group, goal: value } : group)); };
  const handlecgptConversionEventChange = (value, id) => { setCgptGoalGroups(groups => groups.map(group => group.id === id ? { ...group, event: value } : group)); };
  const handlecgptConversionCurrencyChange = (value, id) => { setCgptGoalGroups(groups => groups.map(group => group.id === id ? { ...group, currency: value } : group)); };

  const getCgptSelectedValue = (items, key, isMultiple = false) => {
    if (isMultiple) { return items.filter(item => item.selected === 'SELECTED').map(item => item[key]); }
    const selectedItem = items.find(item => item.selected === 'SELECTED');
    return selectedItem ? selectedItem[key] : '';
  };

  const handleCgptSelectChange = (index, key, value, valueKey, isMultiple = false) => {
    const updatedRows = cgptConvMessageRow.map((group, i) => {
      if (i === index) {
        return { ...group, [key]: group[key].map(item =>
          isMultiple
            ? (value.includes(item[valueKey]) ? { ...item, selected: 'SELECTED' } : { ...item, selected: '' })
            : (item[valueKey] === value ? { ...item, selected: 'SELECTED' } : { ...item, selected: '' })
        )};
      }
      return group;
    });
    setCgptConvMessageRow(updatedRows);
  };

  const addcgptGoals = () => { setCgptGoalGroups(groups => [ ...groups, { id: groups.length + 1, goal: [], event: '', currency: '' } ]); };
  const removecgptGoals = (id, name) => {
    if(name === 'getCgptValue'){ setCgptConvMessageRow(prevRows => prevRows.filter((_, i) => i !== id)); }
    else { setCgptGoalGroups(groups => groups.filter(group => group.id !== id)); }
  };

  const cgptConversionEventMPData = [
    { value: '', label: 'Select Event' },
    ...cgptConversionEventMP.map((e:any) => ({ value: e.key, label: e.value })),
  ];
  const cgptConversionCurrencyMPData = [
    { value: '', label: 'Select Currency' },
    ...cgptConversionCurrencyMP.map((c:any) => ({ value: c.key, label: c.value, selected: c.selected })),
  ];
  useEffect(() => {
    const selectedEventItem = cgptConversionEventMP.find((item:any) => item.selected === "SELECTED");
    if (selectedEventItem) { setCgptConversionEventValueMP(selectedEventItem.key); }
    const selectedCurrencyItem = cgptConversionCurrencyMP.find((item:any) => item.selected === "SELECTED");
    if (selectedCurrencyItem) { setCgptConversionCurrencyValueMP(selectedCurrencyItem.key); }
  }, [cgptConversionEventMP,cgptConversionCurrencyMP]);

  const cgptConversionGoalData = [
    ...(cgptConversionGoal && typeof cgptConversionGoal === 'object' ?
      Object.keys(cgptConversionGoal).map(key => ({ value: key, label: cgptConversionGoal[key] })) : [])
  ];
  const cgptConversionEventData = [
    { value: '', label: 'Select Event' },
    ...cgptConversionEvent.map((e:any) => ({ value: e.key, label: e.value })),
  ];
  const cgptConversionCurrencyData = [
    { value: '', label: 'Select Currency' },
    ...cgptConversionCurrency.map((c:any) => ({ value: c.key, label: c.value })),
  ];

  const saveChatgptConversionCredentials = () => {
    if(cgptPixelIdValue.trim() === '' || cgptConversionKeyValue.trim() === ''){
      modals.open({ trapFocus:false, title:'Please correct the following errors:', children: (<><Text size="sm">Pixel ID and Conversions API key are required.</Text><Group position="right" mt="sm"><Button onClick={() => modals.closeAll()}>OK</Button></Group></>) });
      return;
    }
    setCgptCredSaving(true);
    CampaignApi.savechatgptconversioncredentials({
      campaign_id: campaign_id || campaignId,
      cgpt_pixel_id: cgptPixelIdValue.trim(),
      cgpt_conversion_api_key: cgptConversionKeyValue.trim()
    })
    .then(response => { if (response.ok) { return response.json(); } else { if (response.status === 401 || response.status === 400) { navigate("/logout"); } } })
    .then(data => {
      setCgptCredSaving(false);
      if(data && data.status === 1){
        setCgptHasConversionKey(true);
        setCgptConversionKeyValue('');
        notifications.show({ color: 'green', icon: <IconCheck size="1.1rem" />, title: 'Success', message: data.message });
      } else {
        notifications.show({ color: 'red', icon: <IconX size="1.1rem" />, title: 'Error', message: (data && data.message) ? data.message : 'Could not validate credentials.' });
      }
    })
    .catch(error => { setCgptCredSaving(false); console.log(error); });
  };
  /*end chatgpt step 5*/

  /*start facebook step 5*/
    const getconversiondata = () => {
      settabLoader(true);
      CampaignApi.getconversiondata({
        campaign_id : campaign_id || campaignId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setFbConvMessageRow(data.data.message_row || []);

          setFbConversionGoal(data.data.fb_conversion_goal_event.fb_conversion_goal || []);
          setFbConversionEvent(data.data.fb_conversion_goal_event.fb_conversion_event || []);
          setFbConversionCurrency(data.data.fb_conversion_goal_event.fb_conversion_currency || []);
          if(facebookConversionPageview === true){
            setFacebookConversionPageview(true);
          } else {
            setFacebookConversionPageview(data.data.message_pageview.facebook_conversion_pageview);
          }
          setFbConversionCurrencyMP(data.data.message_pageview.fb_conversion_currency || []);
          setFbConversionEventMP(data.data.message_pageview.fb_conversion_event || []);
          settabLoader(false);
        }
      })
      .catch(error => {
        console.log(error);
        settabLoader(false);
      });
    };

    const getfbpixeldetails = () => {
      settabLoader(true);
      CampaignApi.getfbpixeldetails({
        campaign_id : campaign_id || campaignId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          if(data.data.adaccount_details === "No Data Found."){
            setFbAdAccountDetails(data.data.adaccount_details || {});  
          }
          if(data.data.adaccount_details !== "No Data Found."){
            const adAccountDetailsArray = Object.values(data.data.adaccount_details || {});
            setFbAdAccountDetails(adAccountDetailsArray);
          }
          settabLoader(false);
        }
      })
      .catch(error => {
        settabLoader(false);
        console.log(error);
      });
    };

    useEffect(() => {
      if(setStep5Show !== '0'){
        if (activeTab === 'Facebook') {
          getconversiondata();
          getfbpixeldetails();
        }
      }
    }, [activeTab,setStep5Show]);
  /*End facebook step 5*/

  /*start google step 5*/
    const getgoogleconvadcustomer = () => {
      CampaignApi.getgoogleconvadcustomer({
        campaign_id : campaign_id || campaignId,
        gl_conv_customer_id : glConvCustomerId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setGlCustomer(data.data.adaccount_details);
          const selectedglCustomer = data.data.adaccount_details.find((item) => item.selected === "selected");
          if (selectedglCustomer) {
            setGlCustomerValue(selectedglCustomer.key);
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    };

    const getgoogleconvadsubcustomer = (value) => {
      CampaignApi.getgoogleconvadsubcustomer({
        customer_id : value || glCustomerValue,
        gl_conv_subcustomer_id : glConvSubCustomerId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setGlSubCustomer(data.data.adaccount_details);
          const selectedglSubCustomer = data.data.adaccount_details.find((item) => item.selected === "selected");
          if (selectedglSubCustomer) {
            setGlSubCustomerValue(selectedglSubCustomer.key);
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    };

    const getgoogleconversiondata = () => {
      settabLoader(true);
      CampaignApi.getgoogleconversiondata({
        campaign_id : campaign_id || campaignId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          settabLoader(false);
          setGlConvMessageRow(data.data.message_row || []);
          if(googleConversionPageview === true){
            setGoogleConversionPageview(true);
          } else {
            setGoogleConversionPageview(data.data.message_pageview_gl.google_conversion_pageview);
          }
          setGlConversionActionMP(data.data.message_pageview_gl.gl_conv_action_resource_name_pageview || []);
        }
      })
      .catch(error => {
        settabLoader(false);
        console.log(error);
      });
    };

    const getgoogleconversionpagedetail = () => {
      settabLoader(true);
      CampaignApi.getgoogleconversionpagedetail({
        campaign_id : campaign_id || campaignId,
        customer_id : glCustomerValue,
        subcustomer_id : glSubCustomerValue
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          settabLoader(false);
          setGlConvAction(data.data.adaccount_details || []);
          setGlConvPageDetail(data.data.gl_conv_page_detail || []);
        }
      })
      .catch(error => {
        settabLoader(false);
        console.log(error);
      });
    };

    useEffect(() => {
      if (activeTab === 'Google') {
        getgoogleconvadcustomer();
        getgoogleconversiondata();
      };
    }, [activeTab]);

    useEffect(() => {
      if(glCustomerValue){
        setGlCustomerValue(glCustomerValue);
        setGlSubCustomerValue('');
        getgoogleconvadsubcustomer('');
      }
    }, [glCustomerValue]);

    useEffect(() => {
      if(glSubCustomerValue){
        setGlSubCustomerValue(glSubCustomerValue);
        getgoogleconversionpagedetail();
      }
    }, [glSubCustomerValue]);

    useEffect(() => {
      if(setStep5Show !== '0'){
        if (activeTab === 'Google') {
          getgoogleconversiondata();
          getgoogleconversionpagedetail();
        };
      };
    }, [activeTab,setStep5Show]);
  /*end google step 5*/

  /*start microsoft step 5*/
    const getmicrosoftconvadsaccount = () => {
      settabLoader(true);
      CampaignApi.getmicrosoftconvadsaccount({
        campaign_id : campaign_id || campaignId,
        type : "microsoft_conversion"
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          settabLoader(false);
          setMsAdAccountDetails(data.data.adaccount_details || []);
        }
      })
      .catch(error => {
        settabLoader(false);
        console.log(error);
      });
    };
    
    const getmicrosoftconvgoalname = () => {
      settabLoader(true);
      CampaignApi.getmicrosoftconvgoalname({
        campaign_id : campaign_id || campaignId,
        ms_conv_ads_account_id : msAdAccountDetailsValue
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          settabLoader(false);
          setMsConversionAction(data.data.adaccount_details || []);
          setMsConvPageDetail(data.data.ms_conv_page_detail || []);
        }
      })
      .catch(error => {
        settabLoader(false);
        console.log(error);
      });
    };

    const getmicrosoftconversiondata = () => {
      CampaignApi.getmicrosoftconversiondata({
        campaign_id : campaign_id || campaignId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setMsConvMessageRow(data.data.message_row || []);
          if(microsoftConversionPageview === true){
            setMicrosoftConversionPageview(true);
          } else {
            setMicrosoftConversionPageview(data.data.message_pageview_ms.microsoft_conversion_pageview);
          }
          setMsConversionActionMP(data.data.message_pageview_ms.ms_conv_goal_name_pageview || []);
        }
      })
      .catch(error => {
        console.log(error);
      });
    };

    useEffect(() => {
      if (activeTab === 'Microsoft') {
        getmicrosoftconvadsaccount();
        getmicrosoftconversiondata();
      };
    }, [activeTab]);

    useEffect(() => {
      if(msAdAccountDetailsValue){
        setMsAdAccountDetailsValue(msAdAccountDetailsValue);
        getmicrosoftconvgoalname();
      }
    }, [msAdAccountDetailsValue]);

    useEffect(() => {
      if(setStep5Show !== '0'){
        if (activeTab === 'Microsoft') {
          getmicrosoftconvadsaccount();
          getmicrosoftconversiondata();
        };
      };
    }, [activeTab,setStep5Show]);
  /*end microsoft step 5*/

  /*start taboola step 5*/
    const taboolaconvaduserdata = () => {
      settabLoader(true);
      CampaignApi.taboolaconvaduserdata({
        tb_ad_account_id : tbAdAccountId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          settabLoader(false);
          setTbAdAccountDetails(data.data.adaccount_details || []);
        }
      })
      .catch(error => {
        settabLoader(false);
        console.log(error);
      });
    };
    
    const gettaboolaconversionpagedetail = () => {
      CampaignApi.gettaboolaconversionpagedetail({
        campaign_id : campaign_id || campaignId,
        tb_conv_ad_account_dd : tbAdAccountId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setTbConversionAction(data.data.adaccount_details || []);
          setTbConvPageDetail(data.data.tb_conv_page_detail || []);
        }
      })
      .catch(error => {
        console.log(error);
      });
    };

    const gettaboolaconversiondata = () => {
      CampaignApi.gettaboolaconversiondata({
        campaign_id : campaign_id || campaignId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setTbConvMessageRow(data.data.message_row || []);
          if(taboolaConversionPageview === true){
            setTaboolaConversionPageview(true);
          } else {
            setTaboolaConversionPageview(data.data.message_pageview_tb.taboola_conversion_pageview);
          }
          setTbConversionActionMP(data.data.message_pageview_tb.tb_conv_action_resource_name_pageview || []);
        }
      })
      .catch(error => {
        console.log(error);
      });
    };

    useEffect(() => {
      if (activeTab === 'Taboola') {
        taboolaconvaduserdata();  
        gettaboolaconversionpagedetail();
        gettaboolaconversiondata();
      };
    }, [activeTab]);
  /*end taboola step 5*/

  /*start outbrain step 5*/
    const outbrainconvaduserdata = () => {
      settabLoader(true);
      CampaignApi.outbrainconvaduserdata({
        ob_ad_account_id : obConvadaccountid
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          settabLoader(false);
          setObAdAccountDetails(data.data.adaccount_details || []);
        }
      })
      .catch(error => {
        settabLoader(false);
        console.log(error);
      });
    };
    
    const getoutbrainconversionpagedetail = () => {
      settabLoader(true);
      CampaignApi.getoutbrainconversionpagedetail({
        campaign_id : campaign_id || campaignId,
        ob_conv_ad_account_dd : obAdAccountDetailsValue
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          settabLoader(false);
          setObConversionAction(data.data.adaccount_details || []);
          setObConvPageDetail(data.data.ob_conv_page_detail || []);
        }
      })
      .catch(error => {
        settabLoader(false);
        console.log(error);
      });
    };

    const getoutbrainconversiondata = () => {
      settabLoader(true);
      CampaignApi.getoutbrainconversiondata({
        campaign_id : campaign_id || campaignId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          settabLoader(false);
          if (data.data.message_row && typeof data.data.message_row === 'object') {
            setObConvMessageRow(Object.values(data.data.message_row));
          } else {
            setObConvMessageRow([]);
          }

          if(outbrainConversionPageview === true){
            setOutbrainConversionPageview(true);
          } else {
            setOutbrainConversionPageview(data.data.message_pageview_ob.outbrain_conversion_pageview);
          }
          setObConversionActionMP(data.data.message_pageview_ob.ob_conv_action_resource_name_pageview || []);
        }
      })
      .catch(error => {
        settabLoader(false);
        console.log(error);
      });
    };

    useEffect(() => {
      if (activeTab === 'Outbrain') {
        outbrainconvaduserdata();
        getoutbrainconversiondata();
      };
    }, [activeTab]);

    useEffect(() => {
      if(obAdAccountDetailsValue){
        setObAdAccountDetailsValue(obAdAccountDetailsValue);
        getoutbrainconversionpagedetail();
      }
    }, [obAdAccountDetailsValue]);

    useEffect(() => {
      if(setStep5Show !== '0'){
        if (activeTab === 'Outbrain') {
          getoutbrainconversiondata();
          getoutbrainconversionpagedetail();
        };
      };
    }, [activeTab,setStep5Show]);
  /*end outbrain step 5*/

  /*start tiktok step 5*/
    const gettiktokadvertiseraccount = () => {
      settabLoader(true);
      CampaignApi.gettiktokadvertiseraccount({
        campaign_id : campaign_id || campaignId,
        tk_conv_ads_account_id: tkConvAdAccountId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setTkAdAccountDetails(data.data.adaccount_details || []);
          settabLoader(false);
        }
      })
      .catch(error => {
        console.log(error);
        settabLoader(false);
      });
    };

    const gettiktokconversiondata = () => {
      settabLoader(true);
      CampaignApi.gettiktokconversiondata({
        campaign_id : campaign_id || campaignId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setTkConvMessageRow(data.data.message_row || []);
          if(taboolaConversionPageview === true){
            setTiktokConversionPageview(true);
          } else {
            setTiktokConversionPageview(data.data.message_pageview_tk.tiktok_conversion_pageview);
          }
          setTkConversionPixelMP(data.data.message_pageview_tk.tk_conv_pixel_id_pageview || []);
          setTkConversionEventMP(data.data.message_pageview_tk.tk_conv_event_name_pageview || []);
          settabLoader(false);
        }
      })
      .catch(error => {
        console.log(error);
        settabLoader(false);
      });
    };

    const gettiktokpixel = () => {
      settabLoader(true);
      CampaignApi.gettiktokpixel({
        campaign_id : campaign_id || campaignId,
        advertiserAccountId: tkAdvertiserAccountValue
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setTkPixelAdAccountDetails(data.data.tkpixel_adaccount_details || []);
          setTkEventNamePageview(data.data.tk_conv_event_name_pageview || []);
          setTkConvPageDetail(data.data.tk_conv_page_detail || []);
          settabLoader(false);
        }
      })
      .catch(error => {
        console.log(error);
        settabLoader(false);
      });
    };

    useEffect(() => {
      if(tkAdvertiserAccountValue){
        setTkAdvertiserAccountValue(tkAdvertiserAccountValue);
        gettiktokpixel();
      }
    }, [tkAdvertiserAccountValue]);

    useEffect(() => {
      if(setStep5Show !== '0'){
        if (activeTab === 'Tiktok') {
          gettiktokadvertiseraccount();
          gettiktokconversiondata();
        }
      }
    }, [activeTab,setStep5Show]);
  /*End tiktok step 5*/

  /*start linkedin step 5*/
    const getlinkedinconversiondata = () => {
      settabLoader(true);
      CampaignApi.getlinkedinconversionsdata({
        campaign_id : campaign_id || campaignId,
        ad_account_id : lnadaccountid
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setLnConvMessageRow(data.data.message_row || []);
          if(linkedinConversionPageview === true){
            setLinkedInConversionPageview(true);
          } else {
            setLinkedInConversionPageview(data.data.message_pageview_ln.linkedin_conversion_pageview);
          }
          setLnPageviewConvName(data.data.message_pageview_ln.ln_conv_name_pageview || []);
          setLnConvPageDetail(data.data.ln_conv_page_detail || []);
          settabLoader(false);
        }
      })
      .catch(error => {
        console.log(error);
        settabLoader(false);
      });
    };
    useEffect(() => {
      if(setStep5Show !== '0'){
        if (activeTab === 'LinkedIn') {
          getlinkedinconversiondata();
        }
      }
    }, [activeTab,setStep5Show]);
  /*end linkedin step 5*/

  /*Facebook Step5*/
    const fbConversionGoalData = [
      ...(fbConversionGoal && typeof fbConversionGoal === 'object' ? 
        Object.keys(fbConversionGoal).map(key => ({
          value: key,
          label: fbConversionGoal[key]
        })) 
      : [])
    ];

    const fbConversionEventData = [
      { value: '', label: 'Select Event' },
      ...fbConversionEvent.map((event) => ({
        value: event.key,
        label: event.value,
      })),
    ];

    const fbConversionCurrencyData = [
      { value: '', label: 'Select Currency' },
      ...fbConversionCurrency.map((currency) => ({
        value: currency.key,
        label: currency.value,
      })),
    ];

    useEffect(() => {
      const fbgoalTotalRow = goalGroups.length;
      const fbmessagerowTotalRow = fbConvMessageRow.length;

      setFbTotalRowShow(fbgoalTotalRow + fbmessagerowTotalRow);
    }, [goalGroups,fbConvMessageRow]);

    const handleFbPixelIdChange = (index, value) => {
      setFbPixelIdValue((prev) => ({ ...prev, [index]: value }));
    };

    const handleFbAccessTokenChange = (index, value) => {
      setFbAccessTokenValue((prev) => ({ ...prev, [index]: value }));
    };

    const handlefbConversionGoalChange = (value: string[], id) => {
      /*const allSelectedGoalKeys = getAllSelectedGoalKeys();
      const alreadySelected = value.some(val => allSelectedGoalKeys.includes(val));
      if (alreadySelected) {
        alert("This goal is already selected in other goal Event.");
        return;
      }*/
      setGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, goal: value } : group
        )
      );
    };

    const handlefbConversionEventChange = (value,id) => {
      setGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, event: value } : group
        )
      );
    };

    const handlefbConversionCurrencyChange = (value,id) => {
      setGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, currency: value } : group
        )
      );
    };
    
    const handleFacebookConversionPageviewChange = (event) => {
      setFacebookConversionPageview(event.target.checked);
    };

    const fbConversionEventMPData = [
      { value: '', label: 'Select Event' },
      ...fbConversionEventMP.map((fbConversionEventMP) => ({
        value: fbConversionEventMP.key,
        label: fbConversionEventMP.value
      })),
    ];

    const fbConversionCurrencyMPData = [
      { value: '', label: 'Select Currency' },
      ...fbConversionCurrencyMP.map((fbConversionCurrencyMP) => ({
        value: fbConversionCurrencyMP.key,
        label: fbConversionCurrencyMP.value,
        selected: fbConversionCurrencyMP.selected,
      })),
    ];

    useEffect(() => {
      const selectedEventItem = fbConversionEventMP.find(item => item.selected === "SELECTED");
      if (selectedEventItem) {
        setFbConversionEventValueMP(selectedEventItem.key);
      }
      const selectedCurrencyItem = fbConversionCurrencyMP.find(item => item.selected === "SELECTED");
      if (selectedCurrencyItem) {
        setFbConversionCurrencyValueMP(selectedCurrencyItem.key);
      }
    }, [fbConversionEventMP,fbConversionCurrencyMP]);

    const getFbSelectedValue = (items, key, isMultiple = false) => {
      if (isMultiple) {
        return items.filter(item => item.selected === 'SELECTED').map(item => item[key]);
      }
      const selectedItem = items.find(item => item.selected === 'SELECTED');
      return selectedItem ? selectedItem[key] : '';
    };

    const handleFbSelectChange = (index, key, value, valueKey, isMultiple = false) => {
      /*const allSelectedGoalKeys = getAllSelectedGoalKeys();
      const alreadySelected = value.some(val => allSelectedGoalKeys.includes(val));
      if (alreadySelected) {
        alert("This goal is already selected in another goal event.");
        return;
      }*/

      const updatedRows = fbConvMessageRow.map((group, i) => {
        if (i === index) {
          return {
            ...group,
            [key]: group[key].map(item =>
              isMultiple
                ? value.includes(item[valueKey])
                  ? { ...item, selected: 'SELECTED' }
                  : { ...item, selected: '' }
                : item[valueKey] === value
                ? { ...item, selected: 'SELECTED' }
                : { ...item, selected: '' }
            )
          };
        }
        return group;
      });
      setFbConvMessageRow(updatedRows);
    };


    /*const getAllSelectedGoalKeys = () => {
      return fbConvMessageRow.flatMap((group) => 
        getFbSelectedValue(group.fb_conversion_goal, 'key', true) || []
      );
    };*/

    const addfbGoals = () => {
      setGoalGroups(groups => [
        ...groups,
        { id: groups.length + 1, goal: [], event: '', currency: '' }
      ]);
    };

    const removefbGoals = (id,name) => {
      if(name === 'getFbValue'){
        setFbConvMessageRow(prevRows => prevRows.filter((_, i) => i !== id));
      }else{
        setGoalGroups(groups => groups.filter(group => group.id !== id));
      }
    };
  /*End Facebook Step5*/

  /*Google Step5*/
    const glCustomerData = [
      { value: '', label: 'Select Customer ID' },
      ...glCustomer.map((glCustomer) => ({
        value: glCustomer.key,
        label: glCustomer.value,
        selected: glCustomer.selected,
      })),
    ];

    const glSubCustomerData = [
      { value: '', label: 'Select Sub Customer ID' },
      ...glSubCustomer.map((glSubCustomer) => ({
        value: glSubCustomer.key,
        label: glSubCustomer.value,
        selected: glSubCustomer.selected,
      })),
    ];

    const handleglCustomerChange = (value) => {
      setGlCustomerValue(value);
      setGlSubCustomerValue('');
      getgoogleconvadsubcustomer(value);
      setGlConvActionValue('');
      setGlConvMessageRow([]);
      setGlGoalGroups([]);
    };

    const handleglSubCustomerChange = (value) => {
      setGlSubCustomerValue(value);
      setGlConvActionValue('');
      setGlConvMessageRow([]);
      setGlGoalGroups([]);
    };

    const glConvPageDetailData = glConvPageDetail.map((glConvPageDetail) => ({
        value: glConvPageDetail.key,
        label: glConvPageDetail.value,
      }));

    const glConversionActionMPData = [
      { value: '', label: 'Select Conversion Action' },
      ...glConversionActionMP.map((glConversionActionMP) => ({
        value: glConversionActionMP.key_resource,
        label: glConversionActionMP.value_resource,
      })),
    ];

    useEffect(() => {
      const selectedItem = glConversionActionMP.find(item => item.selected === "selected");
      if (selectedItem) {
        setGlConvActionValue(selectedItem.key_resource);
        setUseglConversionActionMPData(true);
      } else {
        setUseglConversionActionMPData(false);
      }
    }, [glConversionActionMP]); 

    const glConvActionData = [
      { value: '', label: 'Select Conversion Action' },
      ...glConvAction.map((glConvAction) => ({
        value: glConvAction.key,
        label: glConvAction.value,
      })),
    ];

    const handleglConversionActionChange = (value,id) => {
      setGlGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, action: value } : group
        )
      );
    };

    const handleglConvPageGoalChange = (value, id) => {
      /*const allSelectedGoalGlKeys = getAllSelectedGlGoalKeys();
      const alreadySelected = value.some(val => allSelectedGoalGlKeys.includes(val));
      if (alreadySelected) {
        alert("This page is already selected in another goal or event.");
        return;
      }*/

      setGlGoalGroups(groups =>
        groups.map(group =>
          group.id === id ? { ...group, page: value } : group
        )
      );
    };

    const handleGoogleConversionPageviewChange = (event) => {
      setGoogleConversionPageview(event.target.checked);
    };

    const getGlSelectedValue = (items, key, isMultiple = false) => {
      if (isMultiple) {
        return items.filter(item => item.selected === 'selected').map(item => item[key]);
      }
      const selectedItem = items.find(item => item.selected === 'selected');
      return selectedItem ? selectedItem[key] : '';
    };

    const handleGlSelectChange = (index, key, value, valueKey, isMultiple = false) => {
      
      /*const allSelectedGoalGlKeys = getAllSelectedGlGoalKeys();
      const alreadySelected = value.some(val => allSelectedGoalGlKeys.includes(val));
      if (alreadySelected) {
        alert("This goal is already selected in another goal event.");
        return;
      }*/

      const updatedRows = glConvMessageRow.map((group, i) => {
        if (i === index) {
          return {
            ...group,
            [key]: group[key].map(item =>
              isMultiple
                ? value.includes(item[valueKey])
                  ? { ...item, selected: 'selected' }
                  : { ...item, selected: '' }
                : item[valueKey] === value
                ? { ...item, selected: 'selected' }
                : { ...item, selected: '' }
            )
          };
        }
        return group;
      });
      setGlConvMessageRow(updatedRows);
    };

    /*const getAllSelectedGlGoalKeys = () => {
       const selectedFromMessageRow = glConvMessageRow.flatMap(group => 
        getGlSelectedValue(group.gl_conv_page_id, 'key_goal_gl', true) || []
      );
      const selectedFromGoalGroups = glgoalGroups.flatMap(group => group.page || []);
      return [...selectedFromMessageRow, ...selectedFromGoalGroups];
    };*/

    const addglGoals = () => {
      let showMessage = false;
      let errorMessage = '';
      if(glCustomerValue === ''){
        showMessage = true;
        errorMessage += "Please select Customer ID.\n";
      }
      if(glSubCustomerValue === ''){
        showMessage = true;
        errorMessage += "Please select Sub Customer ID.\n";
      }
      if(showMessage){
        modals.open({
          trapFocus: false,
          title: 'Please correct the following errors:',
          children: (
          <>
            <Text size="sm" style={{ whiteSpace: "pre-line" }}>
              {errorMessage.trim()}
            </Text>
            <Group position="right" mt="sm">
              <Button onClick={() => modals.closeAll()}>OK</Button>
            </Group>
          </>
          ),
        });
        return;
      }
      setGlGoalGroups(groups => [
        ...groups,
        { id: groups.length + 1, action: '', page: '' }
      ]);
    };

    const removeglGoals = (id,name) => {
      if(name === 'getGlValue'){
        setGlConvMessageRow(prevRows => prevRows.filter((_, i) => i !== id));
      }else{
        setGlGoalGroups(groups => groups.filter(group => group.id !== id));
      }
    };

    useEffect(() => {
      const glgoalTotalRow = glgoalGroups.length;
      const glmessagerowTotalRow = glConvMessageRow.length;

      setGlTotalRowShow(glgoalTotalRow + glmessagerowTotalRow);
    }, [glgoalGroups,glConvMessageRow]);
  /*End Google Step5*/

  /*Microsoft Step5*/
    const msAdAccountDetailsData = [
      { value: '', label: 'Select Ads Account ID' },
      ...msAdAccountDetails.map((msAdAccountDetails) => ({
        value: msAdAccountDetails.key,
        label: msAdAccountDetails.value,
        selected: msAdAccountDetails.selected,
      })),
    ];

    useEffect(() => {
      const selectedItem = msAdAccountDetails.find(item => item.selected === "selected");
      if (selectedItem) {
        setMsAdAccountDetailsValue(selectedItem.key);
      } else {
        setMsAdAccountDetailsValue('');
      }
    }, [msAdAccountDetails]);

    const msConversionActionMPData = [
      { value: '', label: 'Select Conversion Action' },
      ...msConversionActionMP.map((msConversionActionMP) => ({
        value: msConversionActionMP.id,
        label: msConversionActionMP.name,
      })),
    ];

    const msConversionActionData = [
      { value: '', label: 'Select Conversion Action' },
      ...msConversionAction.map((msConversionAction) => ({
        value: msConversionAction.id,
        label: msConversionAction.name,
      })),
    ];

    useEffect(() => {
      const selectedItem = msConversionActionMP.find(item => item.selected === "selected");
      if (selectedItem) {
        setMsConvActionValue(selectedItem.id);
        setUseMsConversionActionMPData(true);
      } else {
        setMsConvActionValue('');
        setUseMsConversionActionMPData(false);
      }
    }, [msConversionActionMP]); 

    const msConvPageDetailData = [
      { value: '', label: 'Select Conversion Page' },
      ...msConvPageDetail.map((msConvPageDetail) => ({
        value: msConvPageDetail.key,
        label: msConvPageDetail.value,
      })),
    ];


    const handlemsAdAccountDetailsChange = (value) => {
      setMsAdAccountDetailsValue(value);
      setMsConvActionValue('');
      setMsConversionAction([]);
      setMsConvPageDetail([]);
      setMsConversionActionMP([]);
      setMsConvMessageRow([]);
      setMsGoalGroups([]);
    };

    const handleMicrosoftConversionPageviewChange = (event) => {
      setMicrosoftConversionPageview(event.target.checked);
    };

    const getMsSelectedValue = (items, key) => {
      const selectedItem = items.find(item => item.selected === 'selected');
      return selectedItem ? selectedItem[key] : '';
    };

    const handleMsSelectChange = (index, key, value, valueKey) => {
      const updatedRows = msConvMessageRow.map((group, i) => {
        if (i === index) {
          return {
            ...group,
            [key]: group[key].map(item =>
              item[valueKey] === value
                ? { ...item, selected: 'selected' }
                : { ...item, selected: '' }
            )
          };
        }
        return group;
      });
      setMsConvMessageRow(updatedRows);
    };

    const handlemsConvPageDetailChange = (value,id) => {
      setMsGoalGroups(groups =>
        groups.map(group => 
          group.id === id ? { ...group, page: value } : group
        )
      );
    };

    const handlemsConversionActionChange = (value,id) => {
      setMsGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, action: value } : group
        )
      );
    };

    const addmsGoals = () => {
      setMsGoalGroups(groups => [
        ...groups,
        { id: groups.length + 1, action: '', page: '' }
      ]);
    };

    const removemsGoals = (id,name) => {
      if(name === 'getMsValue'){
        setMsConvMessageRow(prevRows => prevRows.filter((_, i) => i !== id));
      }else{
        setMsGoalGroups(groups => groups.filter(group => group.id !== id));
      }
    };
  /*End Microsoft Step5*/

  /*Taboola Step5*/
    const tbAdAccountDetailsData = [
      { value: '', label: 'Select Ads Account ID' },
      ...tbAdAccountDetails.map((tbAdAccountDetails) => ({
        value: tbAdAccountDetails.key,
        label: tbAdAccountDetails.value,
        selected: tbAdAccountDetails.selected,
      })),
    ];

    useEffect(() => {
      const selectedItem = tbAdAccountDetails.find(item => item.selected === "selected");
      if (selectedItem) {
        setTbAdAccountDetailsValue(selectedItem.key);
      } else {
        setTbAdAccountDetailsValue('');
      }
    }, [tbAdAccountDetails]);

    const tbConversionActionMPData = [
      { value: '', label: 'Select Conversion Action' },
      ...tbConversionActionMP.map((tbConversionActionMP) => ({
        value: tbConversionActionMP.event_name,
        label: tbConversionActionMP.display_name,
      })),
    ];

    const tbConversionActionData = [
      { value: '', label: 'Select Conversion Action' },
      ...tbConversionAction.map((tbConversionAction) => ({
        value: tbConversionAction.event_name,
        label: tbConversionAction.display_name,
      })),
    ];

    useEffect(() => {
      const selectedItem = tbConversionActionMP.find(item => item.selected === "selected");
      if (selectedItem) {
        setTbConvActionValue(selectedItem.event_name);
        setUseTbConversionActionMPData(true);
      } else {
        setTbConvActionValue('');
        setUseTbConversionActionMPData(false);
      }
    }, [tbConversionActionMP]); 

    const tbConvPageDetailData = [
      { value: '', label: 'Select Conversion Page' },
      ...tbConvPageDetail.map((tbConvPageDetail) => ({
        value: tbConvPageDetail.key,
        label: tbConvPageDetail.value,
      })),
    ];


    const handletbAdAccountDetailsChange = (value) => {
      setTbAdAccountDetailsValue(value);
      setTbConvActionValue('');
    };

    const handleTaboolaConversionPageviewChange = (event) => {
      setTaboolaConversionPageview(event.target.checked);
    };

    const getTbSelectedValue = (items, key) => {
      const selectedItem = items.find(item => item.selected === 'selected');
      return selectedItem ? selectedItem[key] : '';
    };

    const handleTbSelectChange = (index, key, value, valueKey) => {
      const updatedRows = tbConvMessageRow.map((group, i) => {
        if (i === index) {
          return {
            ...group,
            [key]: group[key].map(item =>
              item[valueKey] === value
                ? { ...item, selected: 'selected' }
                : { ...item, selected: '' }
            )
          };
        }
        return group;
      });
      setTbConvMessageRow(updatedRows);
    };

    const handletbConvPageDetailChange = (value,id) => {
      setTbGoalGroups(groups =>
        groups.map(group => 
          group.id === id ? { ...group, page: value } : group
        )
      );
    };

    const handletbConversionActionChange = (value,id) => {
      setTbGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, action: value } : group
        )
      );
    };

    const addtbGoals = () => {
      setTbGoalGroups(groups => [
        ...groups,
        { id: groups.length + 1, action: '', page: '' }
      ]);
    };

    const removetbGoals = (id,name) => {
      if(name === 'getTbValue'){
        setTbConvMessageRow(prevRows => prevRows.filter((_, i) => i !== id));
      }else{
        setTbGoalGroups(groups => groups.filter(group => group.id !== id));
      }
    };
  /*End Taboola Step5*/

  /*Outbrain Step5*/
    const obAdAccountDetailsData = [
      { value: '', label: 'Select Ads Account ID' },
      ...obAdAccountDetails.map((obAdAccountDetails) => ({
        value: obAdAccountDetails.id,
        label: obAdAccountDetails.name,
        selected: obAdAccountDetails.selected,
      })),
    ];

    useEffect(() => {
      const selectedItem = obAdAccountDetails.find(item => item.selected === "selected");
      if (selectedItem) {
        setObAdAccountDetailsValue(selectedItem.id);
      } else {
        setObAdAccountDetailsValue('');
      }
    }, [obAdAccountDetails]);

    const obConversionActionMPData = [
      { value: '', label: 'Select Conversion Action' },
      ...obConversionActionMP.map((obConversionActionMP) => ({
        value: obConversionActionMP.key,
        label: obConversionActionMP.value,
      })),
    ];

    const obConversionActionData = [
      { value: '', label: 'Select Conversion Action' },
      ...obConversionAction.map((obConversionAction) => ({
        value: obConversionAction.key,
        label: obConversionAction.value,
      })),
    ];

    useEffect(() => {
      const selectedItem = obConversionActionMP.find(item => item.selected === "selected");
      if (selectedItem) {
        setObConvActionValue(selectedItem.key);
        setUseObConversionActionMPData(true);
      } else {
        setObConvActionValue('');
        setUseObConversionActionMPData(false);
      }
    }, [obConversionActionMP]); 

    const obConvPageDetailData = [
      { value: '', label: 'Select Conversion Page' },
      ...obConvPageDetail.map((obConvPageDetail) => ({
        value: obConvPageDetail.key,
        label: obConvPageDetail.value,
      })),
    ];

    const handleobAdAccountDetailsChange = (value) => {
      setObAdAccountDetailsValue(value);
      setObConvActionValue('');
      setObConversionAction([]);
      setObConvPageDetail([]);
      setObConversionActionMP([]);
      setObConvMessageRow([]);
      setObGoalGroups([]);
    };

    const handleOutbrainConversionPageviewChange = (event) => {
      setOutbrainConversionPageview(event.target.checked);
    };

    const getObSelectedValue = (items, key) => {
      const selectedItem = items.find(item => item.selected === 'selected');
      return selectedItem ? selectedItem[key] : '';
    };

    const handleObSelectChange = (index, key, value, valueKey) => {
      const updatedRows = obConvMessageRow.map((group, i) => {
        if (i === index) {
          return {
            ...group,
            [key]: group[key].map(item =>
              item[valueKey] === value
                ? { ...item, selected: 'selected' }
                : { ...item, selected: '' }
            )
          };
        }
        return group;
      });
      setObConvMessageRow(updatedRows);
    };

    const handleobConvPageDetailChange = (value,id) => {
      setObGoalGroups(groups =>
        groups.map(group => 
          group.id === id ? { ...group, page: value } : group
        )
      );
    };

    const handleobConversionActionChange = (value,id) => {
      setObGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, action: value } : group
        )
      );
    };

    const addobGoals = () => {
      setObGoalGroups(groups => [
        ...groups,
        { id: groups.length + 1, action: '', page: '' }
      ]);
    };

    const removeobGoals = (id,name) => {
      if(name === 'getObValue'){
        setObConvMessageRow(prevRows => prevRows.filter((_, i) => i !== id));
      }else{
        setObGoalGroups(groups => groups.filter(group => group.id !== id));
      }
    };
  /*End Outbrain Step5*/

  /*Tiktok Step5*/
    const tkAdvertiserAccountData = [
      { value: '', label: 'Select Advertiser Account', selected: false },
      ...tkAdAccountDetails.map((account) => ({
        value: account.advertiser_id,
        label: account.advertiser_name,
        selected: account.selected,
      })),
    ];

    useEffect(() => {
      const selectedItem = tkAdAccountDetails.find(item => item.selected === "selected");
      if (selectedItem) {
        setTkAdvertiserAccountValue(selectedItem.advertiser_id);
      } else {
        setTkAdvertiserAccountValue('');
      }
    }, [tkAdAccountDetails]);

    const tkConversionPixelMPData = [
      { value: '', label: 'Select Pixel' },
      ...tkConversionPixelMP.map((tkConversionPixelMP) => ({
        value: tkConversionPixelMP.pixel_code,
        label: tkConversionPixelMP.pixel_name,
      })),
    ];

    const tkConversionPixelData = [
      { value: '', label: 'Select Pixel' },
      ...tkPixelAdAccountDetails.map((tkConversionPixel) => ({
        value: tkConversionPixel.pixel_code,
        label: tkConversionPixel.pixel_name,
      })),
    ];

    const tkConversionEventMPData = [
      { value: '', label: 'Select Event Name' },
      ...tkConversionEventMP.map((tkConversionEventMP) => ({
        value: tkConversionEventMP.key,
        label: tkConversionEventMP.value,
      })),
    ];

    const tkConversionEventData = [
      { value: '', label: 'Select Event Name' },
      ...tkEventNamePageview.map((tkEventNamePageview) => ({
        value: tkEventNamePageview.key,
        label: tkEventNamePageview.value,
      })),
    ];

    useEffect(() => {
      const selectedItem = tkConversionPixelMP.find(item => item.selected === "selected");
      if (selectedItem) {
        setTkConvPixelValue(selectedItem.pixel_code);
        setUseTkConversionPixelMPData(true);
      } else {
        setTkConvPixelValue('');
        setUseTkConversionPixelMPData(false);
      }
    }, [tkConversionPixelMP]);

    useEffect(() => {
      const selectedItem = tkConversionEventMP.find(item => item.selected === "SELECTED");
      if (selectedItem) {
        setTkConvEventValue(selectedItem.key);
        setUseTkConversionEventMPData(true);
      } else {
        setTkConvEventValue('');
        setUseTkConversionEventMPData(false);
      }
    }, [tkConversionEventMP]); 

    const tkConvPageDetailData = [
      { value: '', label: 'Select Conversion Page' },
      ...tkConvPageDetail.map((tkConvPageDetail) => ({
        value: tkConvPageDetail.key,
        label: tkConvPageDetail.value,
      })),
    ];

    const handletkAdvertiserAccountChange = (value) => {
      setTkAdvertiserAccountValue(value);
      setTkConvPixelValue('');
      setTkConvEventValue('');
      setTkConversionPixelMP([]);
      setTkPixelAdAccountDetails([]);
      setTkEventNamePageview([]);
      setTkConvMessageRow([]);
      setTkGoalGroups([]);
    };

    const handleTiktokConversionPageviewChange = (event) => {
      setTiktokConversionPageview(event.target.checked);
    };

    const getTkSelectedValue = (items, key) => {
      const selectedItem = items.find(item => item.selected === 'selected' || item.selected === 'SELECTED');
      return selectedItem ? selectedItem[key] : '';
    };

    const handleTkSelectChange = (index, key, value, valueKey) => {
      const updatedRows = tkConvMessageRow.map((group, i) => {
        if (i === index) {
          return {
            ...group,
            [key]: group[key].map(item =>
              item[valueKey] === value
                ? { ...item, selected: 'selected' }
                : { ...item, selected: '' }
            )
          };
        }
        return group;
      });
      setTkConvMessageRow(updatedRows);
    };

    const handletkConvPageDetailChange = (value,id) => {
      setTkGoalGroups(groups =>
        groups.map(group => 
          group.id === id ? { ...group, page: value } : group
        )
      );
    };

    const handletkConversionPixelChange = (value,id) => {
      setTkGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, pixel: value } : group
        )
      );
    };

    const handletkConversionEventChange = (value,id) => {
      setTkGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, event: value } : group
        )
      );
    };

    const addtkGoals = () => {
      setTkGoalGroups(groups => [
        ...groups,
        { id: groups.length + 1, pixel: '', event: '', page: '' }
      ]);
    };

    const removetkGoals = (id,name) => {
      if(name === 'getTkValue'){
        setTkConvMessageRow(prevRows => prevRows.filter((_, i) => i !== id));
      }else{
        setTkGoalGroups(groups => groups.filter(group => group.id !== id));
      }
    };
  /*End Tiktok Step5*/

  /*LinkedIn Step5*/
    const lnConvNamePageviewData = [
      { value: '', label: 'Select Conversion Name' },
      ...lnPageviewConvName.map((item) => ({
        value: item.key,
        label: item.value
      })),
    ];

    const lnConvPageDetailData = lnConvPageDetail.map((lnConvPageDetail) => ({
      value: lnConvPageDetail.key,
      label: lnConvPageDetail.value,
    }));

    useEffect(() => {
      const selectedItem = lnPageviewConvName.find(item => item.selected === "selected");
      if (selectedItem) {
        setLnConvNameValue(selectedItem.key);
        // setUselnConversionPageviewData(true);
      } else {
        setLnConvNameValue('');
        // setUselnConversionPageviewData(false);
      }
    }, [lnPageviewConvName]); 

    /*const handleLinkedInConversionPageviewChange = (event) => {
      setLinkedInConversionPageview(event.target.checked);
    };*/

    useEffect(() => {
      const lngoalTotalRow = lngoalGroups.length;
      const lnmessagerowTotalRow = lnConvMessageRow.length;

      setLnTotalRowShow(lngoalTotalRow + lnmessagerowTotalRow);
    }, [lngoalGroups,lnConvMessageRow]);

    const getLnSelectedValue = (items, key) => {
      const selectedItem = items.find(item => item.selected === 'selected');
      return selectedItem ? selectedItem[key] : '';
    };

    const handleLnSelectChange = (index, key, value, valueKey) => {
      const updatedRows = lnConvMessageRow.map((group, i) => {
        if (i === index) {
          return {
            ...group,
            [key]: group[key].map(item =>
              item[valueKey] === value
                ? { ...item, selected: 'selected' }
                : { ...item, selected: '' }
            )
          };
        }
        return group;
      });
      setLnConvMessageRow(updatedRows);
    };

    const handlelnConversionGoalChange = (value, id) => {
      setLnGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, goal: value } : group
        )
      );
    };

    const handlelnConversionNameChange = (value,id) => {
      setLnGoalGroups(groups => 
        groups.map(group => 
          group.id === id ? { ...group, name: value } : group
        )
      );
    };

    const addlnGoals = () => {
      setLnGoalGroups(groups => [
        ...groups,
        { id: groups.length + 1, goal: [], name: '' }
      ]);
    };

    const removelnGoals = (id,name) => {
      if(name === 'getLnValue'){
        setLnConvMessageRow(prevRows => prevRows.filter((_, i) => i !== id));
      }else{
        setLnGoalGroups(groups => groups.filter(group => group.id !== id));
      }
    };
  /*End LinkedIn Step5*/

/*Start Save Conversion Data*/
  const handleSaveConversionData = () => {
    const fbPixelArray = Array.isArray(fbAdAccountDetails)
    ? fbAdAccountDetails.map((element, index) => ({
        fb_ad_account_id: fbAccountIdValue[index] ?? element.fb_account_id,
        fb_pixel_id: fbPixelIdValue[index] ?? element.fb_pixel_id,
        fb_access_token: fbAccessTokenValue[index] ?? element.fb_access_token
      }))
    : [];

    const fbConversionGoal = {};
    const fbConversionEvent = {};
    const fbConversionCurrency = {};

    const getValidNumbers = (values) => {
      return values
        .map(value => parseInt(value, 10))
        .filter(value => !isNaN(value))
        .join(',');
    };

    fbConvMessageRow.forEach((group, index) => {   
      const fbGoalValues = getFbSelectedValue(group.fb_conversion_goal, 'key', true);           
      fbConversionGoal[`${index + 1}`] = getValidNumbers(fbGoalValues);
      fbConversionEvent[`${index + 1}`] = getFbSelectedValue(group.fb_conversion_event, 'key');
      fbConversionCurrency[`${index + 1}`] = getFbSelectedValue(group.fb_conversion_currency, 'key');
    });

    goalGroups.forEach((group, i) => {
      const adjustedIndex = fbConvMessageRow.length + i + 1;
      fbConversionGoal[`${adjustedIndex}`] = group.goal.map(value => parseInt(value, 10)).join(',');
      fbConversionEvent[`${adjustedIndex}`] = group.event;
      fbConversionCurrency[`${adjustedIndex}`] = group.currency;
    });

    const glConversionAction = {};
    const glConvPageDetail = {};

    glConvMessageRow.forEach((group, index) => {
      const glGoalValues = getGlSelectedValue(group.gl_conv_page_id, 'key_goal_gl', true);           
      glConvPageDetail[`${index + 1}`] = getValidNumbers(glGoalValues);
      glConversionAction[`${index + 1}`] = getGlSelectedValue(group.gl_conv_action_resource_name, 'key_resource');
    });

    glgoalGroups.forEach((group, i) => {
      const adjustedIndex = glConvMessageRow.length + i + 1;
      glConvPageDetail[`${adjustedIndex}`] = (Array.isArray(group.page) ? group.page : []).map(value => parseInt(value, 10)).join(',');
      glConversionAction[`${adjustedIndex}`] = group.action;
    });

    const tbConversionActionValue = tbgoalGroups.map(group => group.action).join(',');
    const tbConvPageDetailValue = tbgoalGroups.map(group => group.page).join(',');

    const tb_conv_action_resource_name = tbConvMessageRow.map(group => 
      getTbSelectedValue(group.tb_conv_action_resource_name, 'event_name')
    ).join(',');

    const tb_conv_page_id = tbConvMessageRow.map(group => 
      getTbSelectedValue(group.tb_conv_page_id, 'key_goal_tb')
    ).join(',');

    const tbConversionAction = `${tb_conv_action_resource_name},${tbConversionActionValue}`;
    const tbConvPageDetail = `${tb_conv_page_id},${tbConvPageDetailValue}`;

    const obConversionActionValue = obgoalGroups.map(group => group.action).join(',');
    const obConvPageDetailValue = obgoalGroups.map(group => group.page).join(',');

    const ob_conv_action_resource_name = obConvMessageRow.map(group => 
      getObSelectedValue(group.ob_conv_action_resource_name, 'key')
    ).join(',');

    const ob_conv_page_id = obConvMessageRow.map(group => 
      getObSelectedValue(group.ob_conv_page_id, 'key')
    ).join(',');

    const obConversionAction = `${ob_conv_action_resource_name},${obConversionActionValue}`;
    const obConvPageDetail = `${ob_conv_page_id},${obConvPageDetailValue}`;

    const msConversionActionValue = msgoalGroups.map(group => group.action).join(',');
    const msConvPageDetailValue = msgoalGroups.map(group => group.page).join(',');

    const ms_conv_goal_name = msConvMessageRow.map(group => 
      getMsSelectedValue(group.ms_conv_goal_name, 'id')
    ).join(',');

    const ms_conv_page_id = msConvMessageRow.map(group => 
      getMsSelectedValue(group.ms_conv_page_id, 'key_goal_ms')
    ).join(',');

    const msConversionAction = `${ms_conv_goal_name},${msConversionActionValue}`;
    const msConvPageDetail = `${ms_conv_page_id},${msConvPageDetailValue}`;
    const tkConversionPixelValue = tkgoalGroups.map(group => group.pixel).join(',');
    const tkConversionEventValue = tkgoalGroups.map(group => group.event).join(',');
    const tkConvPageDetailValue = tkgoalGroups.map(group => group.page).join(',');

    const tk_conv_pixel_id = tkConvMessageRow.map(group => 
      getTkSelectedValue(group.tk_conv_pixel_id, 'pixel_code')
    ).join(',');

    const tk_conv_event_name = tkConvMessageRow.map(group => 
      getTkSelectedValue(group.tk_conv_event_name, 'key')
    ).join(',');

    const tk_conv_page_id = tkConvMessageRow.map(group => 
      getTkSelectedValue(group.tk_conv_page_id, 'key')
    ).join(',');

    const tkConversionPixel = `${tk_conv_pixel_id},${tkConversionPixelValue}`;
    const tkConversionEvent = `${tk_conv_event_name},${tkConversionEventValue}`;
    const tkConvPageDetail = `${tk_conv_page_id},${tkConvPageDetailValue}`;

    const lnConvPageDetailValue = lngoalGroups.map(group => group.goal).join(',');
    const lnConversionNameValue = lngoalGroups.map(group => group.name).join(',');

    const ln_conversion_name = lnConvMessageRow.map(group => 
      getLnSelectedValue(group.ln_conversion_name, 'key_conv_name')
    ).join(',');

    const ln_goal_page_id = lnConvMessageRow.map(group => 
      getLnSelectedValue(group.ln_goal_page_id, 'key_goal_ln')
    ).join(',');

    const lnConversionName = `${ln_conversion_name},${lnConversionNameValue}`;
    const lnConvPageDetail = `${ln_goal_page_id},${lnConvPageDetailValue}`;

    // ChatGPT goal->event/currency maps (1-indexed), mirroring Facebook
    cgptConvMessageRow.forEach((group:any, index:number) => {
      const cgptGoalValues = getCgptSelectedValue(group.cgpt_conversion_goal, 'key', true);
      cgptConversionGoal[`${index + 1}`] = getValidNumbers(cgptGoalValues);
      cgptConversionEvent[`${index + 1}`] = getCgptSelectedValue(group.cgpt_conversion_event, 'key');
      cgptConversionCurrency[`${index + 1}`] = getCgptSelectedValue(group.cgpt_conversion_currency, 'key');
    });
    cgptgoalGroups.forEach((group:any, i:number) => {
      const adjustedIndex = cgptConvMessageRow.length + i + 1;
      cgptConversionGoal[`${adjustedIndex}`] = group.goal.map((value:any) => parseInt(value, 10)).join(',');
      cgptConversionEvent[`${adjustedIndex}`] = group.event;
      cgptConversionCurrency[`${adjustedIndex}`] = group.currency;
    });

    const conversion_api_type =
      activeTab === 'Facebook' ? 'facebook' :
      activeTab === 'Google' ? 'google ads' :
      activeTab === 'Microsoft' ? 'microsoft ads' :
      activeTab === 'Tiktok' ? 'tiktok ads' :
      activeTab === 'Taboola' ? 'taboola-ads' :
      activeTab === 'Outbrain' ? 'outbrain-ads' :
      activeTab === 'ChatGPT' ? 'chatgpt-ads' :
      activeTab === 'LinkedIn' ? 'linkedin-ads' :
    'facebook';
  
    let hasEmptyGroup = false;
    if (activeTab === 'Facebook' && (!fbConvMessageRow || fbConvMessageRow.length === 0) && (!goalGroups || goalGroups.length === 0 || goalGroups.every(group => !group.event.trim() || (Array.isArray(group.goal) ? group.goal.length === 0 : !group.goal.trim())) )) {
      hasEmptyGroup = true;
    }
    if (activeTab === 'Google' && (!glConvMessageRow || glConvMessageRow.length === 0) && (!glgoalGroups || glgoalGroups.length === 0 || glgoalGroups.every(group => !group.action.trim() || (Array.isArray(group.page) ? group.page.length === 0 : !group.page.trim())) )) {
      hasEmptyGroup = true;
    }
    if (activeTab === 'Microsoft' && (!msConvMessageRow || msConvMessageRow.length === 0) && (!msgoalGroups || msgoalGroups.length === 0 || msgoalGroups.every(group => !group.action || !group.page )) ) {
      hasEmptyGroup = true;
    }
    if (activeTab === 'ChatGPT' && (!cgptConvMessageRow || cgptConvMessageRow.length === 0) && (!cgptgoalGroups || cgptgoalGroups.length === 0 || cgptgoalGroups.every((group:any) => !group.event || (Array.isArray(group.goal) ? group.goal.length === 0 : !group.goal)) ) ) {
      hasEmptyGroup = true;
    }
    if (hasEmptyGroup) {
      modals.open({
        trapFocus: false,
        title: 'Please correct the following errors:',
        children: (
        <>
          <Text size="sm">
            Please add at least one goal to save the campaign
          </Text>
          <Group position="right" mt="sm">
            <Button onClick={() => modals.closeAll()}>OK</Button>
          </Group>
        </>
        ),
      });
      return;
    }

    let hasEmptyCustomer = false;
    let errorMessage = "";

    if (activeTab === 'Facebook' && (fbPixelArray.every(group => (Array.isArray(group.fb_access_token) ? group.fb_access_token.length === 0 : !group.fb_access_token.trim())) )) {
      hasEmptyCustomer = true;
      errorMessage += "Facebook Access Token is required.\n";
    }

    if (activeTab === 'Facebook' && (fbPixelArray.every(group => (Array.isArray(group.fb_pixel_id) ? group.fb_pixel_id.length === 0 : !group.fb_pixel_id.trim())) )) {
      hasEmptyCustomer = true;
      errorMessage += "Facebook Pixel ID is required.\n";
    }

    if (activeTab === 'Google' && (!glCustomerValue || glCustomerValue.length === 0)) {
      hasEmptyCustomer = true;
      errorMessage += "Please Select Customer ID\n";
    }

    if (activeTab === 'Google' && (!glSubCustomerValue || glSubCustomerValue.length === 0)) {
      hasEmptyCustomer = true;
      errorMessage += "Please Select Sub Customer ID\n";
    }

    if (activeTab === 'Outbrain' && (!obAdAccountDetailsValue || obAdAccountDetailsValue.length === 0)) {
      hasEmptyCustomer = true;
      errorMessage += "Please Select Ad Account ID\n";
    }

    if (activeTab === 'Tiktok' && (!tkAdvertiserAccountValue || tkAdvertiserAccountValue.length === 0)) {
      hasEmptyCustomer = true;
      errorMessage += "Please Select Advertiser Account\n";
    }

    if (activeTab === 'Microsoft' && (!msAdAccountDetailsValue || msAdAccountDetailsValue.length === 0)) {
      hasEmptyCustomer = true;
      errorMessage += "Please Select Ads Account ID\n";
    }

    if (activeTab === 'ChatGPT' && !cgptHasConversionKey) {
      hasEmptyCustomer = true;
      errorMessage += "Please save the ChatGPT Pixel ID and Conversions API key first.\n";
    }

    if (hasEmptyCustomer) {
      modals.open({
        trapFocus: false,
        title: 'Please correct the following errors:',
        children: (
        <>
          <Text size="sm" style={{ whiteSpace: "pre-line" }}>
            {errorMessage.trim()}
          </Text>
          <Group position="right" mt="sm">
            <Button onClick={() => modals.closeAll()}>OK</Button>
          </Group>
        </>
        ),
      });
      return;
    }
    campaignLoader(true);
    CampaignApi.saveconversiondata({
      system_website_id : selectedMemberWebsite,
      campaign_id : campaign_id || campaignId,
      conv_attribution_model : convAttributionModel,
      fb_pixel_arr: fbPixelArray,
      fb_total_row: fbTotalRowShow,
      fb_conversion_event_pageview: fbConversionEventValueMP,
      fb_conversion_currency_pageview: fbConversionCurrencyValueMP,
      facebook_conversion_pageview: facebookConversionPageview === true ? 1 : 0,
      fb_conversion_goal: fbConversionGoal,
      fb_conversion_event: fbConversionEvent,
      fb_conversion_currency: fbConversionCurrency,
      send_all_conversion_fb: isFbSendAllConversionChecked === true ? 1 : 0,

      gl_total_row: glTotalRowShow,
      gl_conv_refreshtoken: glUserRefreshtoken !== '' ? 1 : '',
      gl_conv_customer_id: glCustomerValue,
      gl_conv_subcustomer_id: glSubCustomerValue,
      google_conversion_pageview: googleConversionPageview === true ? 1 : 0,
      gl_conv_action_resource_name_pageview: glConvActionValue,
      gl_conv_action_resource_name: glConversionAction,
      gl_conv_page_id: glConvPageDetail,
      
      tb_conv_user_refreshtoken: tbUserRefreshtoken !== '' ? 1 : '',
      tb_conv_ad_account_id: tbAdAccountDetailsValue,
      taboola_conversion_pageview: taboolaConversionPageview === true ? 1 : 0,
      tb_conv_action_resource_name_pageview: tbConvActionValue,
      tb_conv_action_resource_name: tbConversionAction,
      tb_conv_page_id: tbConvPageDetail,

      ob_conv_user_token: obUsertoken !== '' ? 1 : '',
      ob_conv_ad_account_id: obAdAccountDetailsValue,
      outbrain_conversion_pageview: outbrainConversionPageview === true ? 1 : 0,
      ob_conv_action_resource_name_pageview: obConvActionValue,
      ob_conv_action_resource_name: obConversionAction,
      ob_conv_page_id: obConvPageDetail,

      ms_conv_refreshtoken: msUserRefreshtoken !== '' ? 1 : '',
      ms_conv_ads_account_id: msAdAccountDetailsValue,
      microsoft_conversion_pageview: microsoftConversionPageview === true ? 1 : 0,
      ms_conv_goal_name_pageview: msConvActionValue,
      ms_conv_goal_name: msConversionAction,
      ms_conv_page_id: msConvPageDetail,
      conversion_api_type: conversion_api_type,

      tk_conv_access_token: tkUserAccesstoken !== '' ? 1 : '',
      tk_conv_ads_account_id: tkAdvertiserAccountValue,
      tk_conv_pixel_id: tkConversionPixel,
      tk_conv_event_name: tkConversionEvent,
      tk_conv_page_id: tkConvPageDetail,
      tiktok_conversion_pageview: tiktokConversionPageview === true ? 1 : 0,
      tk_conv_pixel_id_pageview: tkConvPixelValue,
      tk_conv_event_name_pageview: tkConvEventValue,

      ln_accesstoken: lnAccesstoken !== '' ? 1 : '',
      ln_conv_ad_account_id: lnadaccountid,
      ln_conv_name: lnConversionName,
      ln_conv_page: lnConvPageDetail,
      linkedin_conversion_pageview: linkedinConversionPageview === true ? 1 : 0,
      ln_total_row: lnTotalRowShow,
      ln_conv_name_pageview: lnConvNameValue,

      cgpt_total_row: cgptTotalRowShow,
      cgpt_conversion_goal: cgptConversionGoal,
      cgpt_conversion_event: cgptConversionEvent,
      cgpt_conversion_currency: cgptConversionCurrency,
      cgpt_conversion_event_pageview: cgptConversionEventValueMP,
      cgpt_conversion_currency_pageview: cgptConversionCurrencyValueMP,
      chatgpt_conversion_pageview: chatgptConversionPageview === true ? 1 : 0
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        campaignLoader(false);
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        navigate("/manage-campaigns");
      }
    })
    .catch(error => {
      campaignLoader(false);
      console.log(error);
    });
  }
/*End Save Conversion Data*/
  const handleTabChange = (value) => {
    if (value === 'Facebook' && !isFacebookChecked) return;
    if (value === 'Google' && !isGoogleChecked) return;
    if (value === 'Microsoft' && !isMicrosoftChecked) return;
    if (value === 'Tiktok' && !isTiktokChecked) return;
    if (value === 'Taboola' && !isTaboolaChecked) return;
    if (value === 'Outbrain' && !isOutbrainChecked) return;
    if (value === 'LinkedIn' && !isLinkedInChecked) return;
    if (value === 'ChatGPT' && !isChatgptChecked) return;
    setActiveTab(value);
  };

  useEffect(() => {
    const tabsMap = {
      'facebook': { name: 'Facebook', isChecked: isFacebookChecked },
      'google ads': { name: 'Google', isChecked: isGoogleChecked },
      'microsoft ads': { name: 'Microsoft', isChecked: isMicrosoftChecked },
      'tiktok ads': { name: 'Tiktok', isChecked: isTiktokChecked },
      'taboola-ads': { name: 'Taboola', isChecked: isTaboolaChecked },
      'outbrain-ads': { name: 'Outbrain', isChecked: isOutbrainChecked },
      'linkedin-ads': { name: 'LinkedIn', isChecked: isLinkedInChecked },
      'chatgpt-ads': { name: 'ChatGPT', isChecked: isChatgptChecked },
    };

    let activeTab = null;
    if (tabsMap[conversionApiType]?.isChecked) {
      activeTab = tabsMap[conversionApiType].name;
    } else {
      const lastCheckedTab = Object.values(tabsMap)
        .reverse()
        .find((tab) => tab.isChecked);
      if (lastCheckedTab) {
        activeTab = lastCheckedTab.name;
      }
    }
    if (activeTab) {
      setActiveTab(activeTab);
    }
  }, [ conversionApiType, isFacebookChecked, isGoogleChecked, isMicrosoftChecked, isTiktokChecked, isTaboolaChecked, isOutbrainChecked, isLinkedInChecked, isChatgptChecked]);

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    if (step5IconRef.current) {
      const { top, left, width } = step5IconRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset,
        left: left + width + 10, 
      });
    }
  };

  return (
    <>
      {showHelpModal &&
        ReactDOM.createPortal(
          <div>
            <SelectTooltip
              isVisible={showHelpModal}
              setIsVisible={setShowHelpModal}
              id={helpTargetId}
              tooltipPosition={tooltipPosition}
            />
          </div>,
        document.body
      )}
      {/*for Step 2 remove and this is step 5 - API Set Up*/}
      {step5Show === '1' && (
      <Accordion.Item className={classes.item} value="step-5">
        <Accordion.Control disabled={step5Disabled}><Text component="span" color="red" weight={500}>Step 4</Text><Text component="span" weight={500}> - API Set Up </Text></Accordion.Control>
        <Accordion.Panel>
          <Group spacing="xs" mb={5}>
            <Text weight={500}>Conversion Attribution:</Text>
            <Select
              data={[
                  { value: '1', label: 'First Click' },
                  { value: '2', label: 'Last Click' },
                  { value: '3', label: 'All' }
                ]}
              value={convAttributionModel}
              onChange={handleConvAttributionModelChange}
              name="conv_attribution_model"
              w={200}
            />
          </Group>
          <Tabs value={activeTab} onTabChange={handleTabChange} style={{ position: 'relative' }}>
          <LoadingOverlay zIndex={9999999999} visible={tabLoader} overlayBlur={2} loaderProps={{variant:"bars", color:"gray"}}/>
          <Tabs.List grow>
            <Tabs.Tab value="Facebook">Facebook</Tabs.Tab>
            <Tabs.Tab value="Google">Google</Tabs.Tab>
            <Tabs.Tab value="Microsoft">Microsoft</Tabs.Tab>
            <Tabs.Tab value="Tiktok">Tiktok</Tabs.Tab>
            <Tabs.Tab value="Taboola">Taboola</Tabs.Tab>
            <Tabs.Tab value="Outbrain">Outbrain</Tabs.Tab>
            <Tabs.Tab value="LinkedIn">LinkedIn</Tabs.Tab>
            <Tabs.Tab value="ChatGPT">ChatGPT</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="Facebook" pt="xs">
            <Table striped highlightOnHover withBorder mb={10}>
              <thead>
                <tr>
                  <th>Ad Account ID</th>
                  <th>Pixel ID</th>
                  <th>Access Token</th>
                </tr>
              </thead>
              <tbody>
                {
                  Array.isArray(fbAdAccountDetails) && fbAdAccountDetails.length > 0 ? (
                  <>
                    {fbAdAccountDetails.map((element,index) => (
                      <tr key={element.fb_account_name}>
                        <td style={{ display: 'none' }}>
                          <input type="hidden" value={fbAccountIdValue['index']} />
                        </td>
                        <td>{element.fb_account_name_id} </td>
                        <td>
                          <Input
                            value={fbPixelIdValue[index] ?? element.fb_pixel_id}
                            onChange={(e) => handleFbPixelIdChange(index, e.target.value)}
                          />
                        </td>
                        <td>
                          <Input
                            value={fbAccessTokenValue[index] ?? element.fb_access_token}
                            onChange={(e) => handleFbAccessTokenChange(index, e.target.value)}
                          />
                        </td>
                      </tr>
                    ))}
                  </>
                  ) : (
                    <tr>
                      <td> </td>
                      <td style={{ textAlign: 'center' }}>No Data Found</td>
                      <td> </td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
            <Group spacing={5} align="center">
              <Checkbox
                name="send_all_conversion_fb"
                checked={isFbSendAllConversionChecked}
                onChange={(event) => handleFbSendAllConversionChange(event)}
                label={<strong>Send All conversion to Facebook</strong>}
              />
              <IconHelp ref={step5IconRef} size="1.1rem" color="red" style={{ cursor: 'pointer'}} onClick={() => handleHelpClick(330)}/>
            </Group>
            <Group mt={10}>
              <Checkbox
                name="facebook_conversion_pageview"
                label={<strong>LP visit push as pageview:</strong>}
                checked={facebookConversionPageview}
                onChange={(event) => handleFacebookConversionPageviewChange(event)}
              />
              <Select
                data={fbConversionEventMPData}
                value={fbConversionEventValueMP}
                onChange={(value) => setFbConversionEventValueMP(value)}
                name="fb_conversion_event_pageview"
                w={250}
              />
              {fbConversionEventValueMP === 'Purchase' && (
                <Select
                  data={fbConversionCurrencyMPData}
                  value={fbConversionCurrencyValueMP}
                  onChange={(value) => setFbConversionCurrencyValueMP(value)}
                  name="fb_conversion_currency_pageview[1][]"
                  w={250}
                />
              )}
            </Group>
            <Text mt={10}>Select the goals you want to pass to Facebook. Then select desired Event to pass for each of your campaign goals.</Text>

            {Array.isArray(fbConvMessageRow) && fbConvMessageRow.length > 0 && (
              <>
                {fbConvMessageRow.map((group, index) => (
                  <Group key={index} mt={10}>
                    <MultiSelect
                      data={group.fb_conversion_goal.map(action => ({
                        value: action.key,
                        label: action.value
                      }))}
                      value={getFbSelectedValue(group.fb_conversion_goal, 'key', true)}
                      onChange={(value) => handleFbSelectChange(index, 'fb_conversion_goal', value, 'key', true)}
                      name={`fb_conversion_goal[${index}][]`}
                      placeholder="Select Goal"
                      w={250}
                      searchable
                      multiple
                    />
                    <Select
                      data={group.fb_conversion_event.map(action => ({
                        value: action.key,
                        label: action.value
                      }))}
                      value={getFbSelectedValue(group.fb_conversion_event, 'key', false)}
                      onChange={(value) => handleFbSelectChange(index, 'fb_conversion_event', value, 'key', false)}
                      name={`fb_conversion_event[${index}][]`}
                      w={250}
                    />
                    {group.fb_conversion_currency_row !== 'hide' && (
                      <Select
                        data={group.fb_conversion_currency.map(action => ({
                          value: action.key,
                          label: action.value
                        }))}
                        value={getFbSelectedValue(group.fb_conversion_currency, 'key', false)}
                        onChange={(value) => handleFbSelectChange(index, 'fb_conversion_currency', value, 'key', false)}
                        name={`fb_conversion_currency[${index}][]`}
                        w={250}
                      />
                    )}
                    <ActionIcon title="Remove">
                      <IconCircleMinus size="1.1rem" color="red" onClick={() => removefbGoals(index,'getFbValue')}/>
                    </ActionIcon>
                  </Group>
                ))}
              </>
            )}

            {goalGroups.map(group => (
              <Group key={group.id} mt={10}>
                <MultiSelect
                    data={fbConversionGoalData}
                    value={group.goal}
                    onChange={(value) => handlefbConversionGoalChange(value, group.id)}
                    name={`fb_conversion_goal[${group.id}][]`}
                    placeholder="Select Goal"
                    w={250}
                    searchable
                    multiple
                  />
                  <Select
                    data={fbConversionEventData}
                    value={group.event}
                    onChange={(value) => handlefbConversionEventChange(value, group.id)}
                    name={`fb_conversion_event[${group.id}][]`}
                    w={250}
                  />
                  {group.event === 'Purchase' && (
                    <Select
                      data={fbConversionCurrencyData}
                      value={group.currency}
                      onChange={(value) => handlefbConversionCurrencyChange(value, group.id)}
                      name={`fb_conversion_currency[${group.id}][]`}
                      w={250}
                    />
                  )}
                  <ActionIcon title="Remove">
                    <IconCircleMinus size="1.1rem" color="red" onClick={() => removefbGoals(group.id,'')}/>
                  </ActionIcon> 
              </Group>
            ))}
            <Button color="teal" mt={10} onClick={addfbGoals}>
              <IconPlus size="1.1rem" color="white"/><Text ml={5}>Add Goal</Text>
            </Button>
          </Tabs.Panel>

          <Tabs.Panel value="Google" pt="xs">
            <Group spacing="xs" mb={5}>
              <Text weight={500}>Customer ID:</Text>
              <Select
                data={glCustomerData}
                value={glCustomerValue}
                onChange={handleglCustomerChange}
                name="gl_conv_customer_id"
                w={200}
                ml={28}
              />
            </Group>
            <Group spacing="xs" mb={5}>
              <Text weight={500}>Sub Customer ID:</Text>
              <Select
                data={glSubCustomerData}
                value={glSubCustomerValue}
                onChange={handleglSubCustomerChange}
                name="gl_conv_subcustomer_id"
                w={200}
              />
            </Group>
            <Group mt={10}>
              <Checkbox
                name="google_conversion_pageview"
                label={<strong>LP visit push as pageview:</strong>}
                checked={googleConversionPageview}
                onChange={(event) => handleGoogleConversionPageviewChange(event)}
              />
              {useglConversionActionMPData ? (
                <Select
                  data={glConversionActionMPData}
                  value={glConvActionValue}
                  onChange={(value) => setGlConvActionValue(value)}
                  name="gl_conv_action_resource_name_pageview"
                  w={250}
                />
              ) : (
                <Select
                  data={glConvActionData}
                  value={glConvActionValue}
                  onChange={(value) => setGlConvActionValue(value)}
                  name="gl_conv_action_resource_name_pageview"
                  w={250}
                />
              )}
            </Group>

            {glConvMessageRow.map((group, index) => (
              <Group key={index} mt={10}>
                <Select
                  data={group.gl_conv_action_resource_name.map(action => ({
                    value: action.key_resource,
                    label: action.value_resource
                  }))}
                  name={`gl_conv_action_resource_name[]`}
                  value={getGlSelectedValue(group.gl_conv_action_resource_name, 'key_resource', false)}
                  onChange={(value) => handleGlSelectChange(index, 'gl_conv_action_resource_name', value, 'key_resource', false)}
                  w={250}
                />
                <MultiSelect
                  data={group.gl_conv_page_id.map(page => ({
                    value: page.key_goal_gl,
                    label: page.value_goal_gl
                  }))}
                  name={`gl_conv_page_id[]`}
                  value={getGlSelectedValue(group.gl_conv_page_id, 'key_goal_gl', true)}
                  onChange={(value) => handleGlSelectChange(index, 'gl_conv_page_id', value, 'key_goal_gl', true)}
                  placeholder="Select Conversion Page"
                  w={250}
                  multiple
                />
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removeglGoals(index,'getGlValue')}/>
                </ActionIcon>
              </Group>
            ))}

            {glgoalGroups.map(group => (
              <Group key={group.id} mt={10}>
                <Select
                    data={glConvActionData}
                    value={group.action}
                    onChange={(value) => handleglConversionActionChange(value, group.id)}
                    name={`gl_conv_action_resource_name[]`}
                    w={250}
                  />
                  <MultiSelect
                    data={glConvPageDetailData}
                    value={group.page}
                    onChange={(value) => handleglConvPageGoalChange(value, group.id)}
                    name={`gl_conv_page_id[]`}
                    placeholder="Select Conversion Page"
                    w={250}
                    multiple
                  />
                  <ActionIcon title="Remove">
                    <IconCircleMinus size="1.1rem" color="red" onClick={() => removeglGoals(group.id,'')}/>
                  </ActionIcon>
              </Group>
            ))}
            <Button color="teal" mt={10} onClick={addglGoals}>
              <IconPlus size="1.1rem" color="white"/><Text ml={5}>Add Goal</Text>
            </Button>
          </Tabs.Panel>

          <Tabs.Panel value="Microsoft" pt="xs">
            <Group spacing="xs" mb={5}>
              <Text weight={500}>Ads Account ID:</Text>
              <Select
                data={msAdAccountDetailsData}
                value={msAdAccountDetailsValue}
                onChange={handlemsAdAccountDetailsChange}
                name="ms_conv_ads_account_id"
                w={200}
                ml={28}
              />
            </Group>
            <Group mt={10}>
              <Checkbox
                name="microsoft_conversion_pageview"
                label={<strong>LP visit push as pageview:</strong>}
                checked={microsoftConversionPageview}
                onChange={(event) => handleMicrosoftConversionPageviewChange(event)}
              />
              {useMsConversionActionMPData ? (
                <Select
                  data={msConversionActionMPData}
                  value={msConvActionValue}
                  onChange={(value) => setMsConvActionValue(value)}
                  name="ms_conv_goal_name_pageview"
                  w={250}
                />
              ) : (
                <Select
                  data={msConversionActionData}
                  value={msConvActionValue}
                  onChange={(value) => setMsConvActionValue(value)}
                  name="ms_conv_goal_name_pageview"
                  w={250}
                />
              )}
            </Group>

            {msConvMessageRow.map((group, index) => (
              <Group key={index} mt={10}>
                <Select
                  data={group.ms_conv_goal_name.map(action => ({
                    value: action.id,
                    label: action.name
                  }))}
                  name={`ms_conv_goal_name[]`}
                  value={getMsSelectedValue(group.ms_conv_goal_name, 'id')}
                  onChange={(value) => handleMsSelectChange(index, 'ms_conv_goal_name', value, 'id')}
                  w={250}
                />
                <Select
                  data={group.ms_conv_page_id.map(page => ({
                    value: page.key_goal_ms,
                    label: page.value_goal_ms
                  }))}
                  name={`ms_conv_page_id[]`}
                  value={getMsSelectedValue(group.ms_conv_page_id, 'key_goal_ms')}
                  onChange={(value) => handleMsSelectChange(index, 'ms_conv_page_id', value, 'key_goal_ms')}
                  w={250}
                />
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removemsGoals(index,'getMsValue')}/>
                </ActionIcon>
              </Group>
            ))}

            {msgoalGroups.map(group => (
              <Group key={group.id} mt={10}>
                <Select
                  data={msConversionActionData}
                  value={group.action}
                  onChange={(value) => handlemsConversionActionChange(value, group.id)}
                  name={`ms_conv_goal_name[]`}
                  w={250}
                />
                <Select
                  data={msConvPageDetailData}
                  value={group.page}
                  onChange={(value) => handlemsConvPageDetailChange(value, group.id)}
                  name={`ms_conv_page_id[]`}
                  w={250}
                />
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removemsGoals(group.id,'')}/>
                </ActionIcon>
              </Group>
            ))}
            <Button color="teal" mt={10} onClick={addmsGoals}>
              <IconPlus size="1.1rem" color="white"/><Text ml={5}>Add Goal</Text>
            </Button>
          </Tabs.Panel>

          <Tabs.Panel value="Tiktok" pt="xs">
            <Group spacing="xs" mb={5}>
              <Text weight={500}>Advertiser Account:</Text>
              <Select
                data={tkAdvertiserAccountData}
                value={tkAdvertiserAccountValue}
                onChange={handletkAdvertiserAccountChange}
                name="tk_conv_ads_account_id"
                w={200}
                ml={28}
              />
            </Group>
            <Group mt={10}>
              <Checkbox
                name="tiktok_conversion_pageview"
                label={<strong>LP visit push as pageview:</strong>}
                checked={tiktokConversionPageview}
                onChange={(event) => handleTiktokConversionPageviewChange(event)}
              />
              {useTkConversionPixelMPData ? (
                <Select
                  data={tkConversionPixelMPData}
                  value={tkConvPixelValue}
                  onChange={(value) => setTkConvPixelValue(value)}
                  name="tk_conv_pixel_id_pageview"
                  w={250}
                />
              ) : (
                <Select
                  data={tkConversionPixelData}
                  value={tkConvPixelValue}
                  onChange={(value) => setTkConvPixelValue(value)}
                  name="tk_conv_pixel_id_pageview"
                  w={250}
                />
              )}
              {useTkConversionEventMPData ? (
                <Select
                  data={tkConversionEventMPData}
                  value={tkConvEventValue}
                  onChange={(value) => setTkConvEventValue(value)}
                  name="tk_conv_event_name_pageview"
                  w={250}
                />
              ) : (
                <Select
                  data={tkConversionEventData}
                  value={tkConvEventValue}
                  onChange={(value) => setTkConvEventValue(value)}
                  name="tk_conv_event_name_pageview"
                  w={250}
                />
              )}
            </Group>
            {tkConvMessageRow.map((group, index) => (
              <Group key={index} mt={10}>
                <Select
                  data={group.tk_conv_pixel_id.map(pixel => ({
                    value: pixel.pixel_code,
                    label: pixel.pixel_name
                  }))}
                  value={getTkSelectedValue(group.tk_conv_pixel_id, 'pixel_code')}
                  onChange={(value) => handleTkSelectChange(index, 'tk_conv_pixel_id', value, 'pixel_code')}
                  name={`tk_conv_pixel_id[]`}
                  w={250}
                />
                <Select
                  data={group.tk_conv_event_name.map(event => ({
                    value: event.key,
                    label: event.value
                  }))}
                  value={getTkSelectedValue(group.tk_conv_event_name, 'key')}
                  onChange={(value) => handleTkSelectChange(index, 'tk_conv_event_name', value, 'key')}
                  name={`tk_conv_event_name[]`}
                  w={250}
                />
                <Select
                  data={group.tk_conv_page_id.map(page => ({
                    value: page.key,
                    label: page.value
                  }))}
                  name={`tk_conv_page_id[]`}
                  value={getTkSelectedValue(group.tk_conv_page_id, 'key')}
                  onChange={(value) => handleTkSelectChange(index, 'tk_conv_page_id', value, 'key')}
                  w={250}
                />
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removetkGoals(index,'getTkValue')}/>
                </ActionIcon>
              </Group>
            ))}

            {tkgoalGroups.map(group => (
              <Group key={group.id} mt={10}>
                <Select
                  data={tkConversionPixelData}
                  value={group.pixel}
                  onChange={(value) => handletkConversionPixelChange(value, group.id)}
                  name={`tk_conv_pixel_id[]`}
                  placeholder="Select Pixel"
                  w={250}
                />
                <Select
                  data={tkConversionEventData}
                  value={group.event}
                  onChange={(value) => handletkConversionEventChange(value, group.id)}
                  name={`tk_conv_event_name[]`}
                  placeholder="Select Event Name"
                  w={250}
                />
                <Select
                  data={tkConvPageDetailData}
                  value={group.page}
                  onChange={(value) => handletkConvPageDetailChange(value, group.id)}
                  name={`tk_conv_page_id[]`}
                  placeholder="Select Conversion Page"
                  w={250}
                />
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removetkGoals(group.id,'')}/>
                </ActionIcon>
              </Group>
            ))}
            <Button color="teal" mt={10} onClick={addtkGoals}>
              <IconPlus size="1.1rem" color="white"/><Text ml={5}>Add Goal</Text>
            </Button>
          </Tabs.Panel>

          <Tabs.Panel value="Taboola" pt="xs">
            <Group spacing="xs" mb={5}>
              <Text weight={500}>Ad Account ID:</Text>
              <Select
                data={tbAdAccountDetailsData}
                value={tbAdAccountDetailsValue}
                onChange={handletbAdAccountDetailsChange}
                name="tb_conv_ad_account_dd"
                w={200}
                ml={28}
              />
            </Group>
            <Group mt={10}>
              <Checkbox
                name="taboola_conversion_pageview"
                label={<strong>LP visit push as pageview:</strong>}
                checked={taboolaConversionPageview}
                onChange={(event) => handleTaboolaConversionPageviewChange(event)}
              />
              {useTbConversionActionMPData ? (
                <Select
                  data={tbConversionActionMPData}
                  value={tbConvActionValue}
                  onChange={(value) => setTbConvActionValue(value)}
                  name="tb_conv_action_resource_name_pageview"
                  w={250}
                />
              ) : (
                <Select
                  data={tbConversionActionData}
                  value={tbConvActionValue}
                  onChange={(value) => setTbConvActionValue(value)}
                  name="tb_conv_action_resource_name_pageview"
                  w={250}
                />
              )}
            </Group>

            {tbConvMessageRow.map((group, index) => (
              <Group key={index} mt={10}>
                <Select
                  data={group.tb_conv_action_resource_name.map(action => ({
                    value: action.event_name,
                    label: action.display_name
                  }))}
                  name={`tb_conv_action_resource_name[]`}
                  value={getTbSelectedValue(group.tb_conv_action_resource_name, 'event_name')}
                  onChange={(value) => handleTbSelectChange(index, 'tb_conv_action_resource_name', value, 'event_name')}
                  w={250}
                />
                <Select
                  data={group.tb_conv_page_id.map(page => ({
                    value: page.key_goal_tb,
                    label: page.value_goal_tb
                  }))}
                  name={`tb_conv_page_id[]`}
                  value={getTbSelectedValue(group.tb_conv_page_id, 'key_goal_tb')}
                  onChange={(value) => handleTbSelectChange(index, 'tb_conv_page_id', value, 'key_goal_tb')}
                  w={250}
                />
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removetbGoals(index,'getTbValue')}/>
                </ActionIcon>
              </Group>
            ))}

            {tbgoalGroups.map(group => (
              <Group key={group.id} mt={10}>
                <Select
                  data={tbConversionActionData}
                  value={group.action}
                  onChange={(value) => handletbConversionActionChange(value, group.id)}
                  name={`tb_conv_action_resource_name[]`}
                  w={250}
                />
                <Select
                  data={tbConvPageDetailData}
                  value={group.page}
                  onChange={(value) => handletbConvPageDetailChange(value, group.id)}
                  name={`tb_conv_page_id[]`}
                  w={250}
                />
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removetbGoals(group.id,'')}/>
                </ActionIcon>
              </Group>
            ))}
            <Button color="teal" mt={10} onClick={addtbGoals}>
              <IconPlus size="1.1rem" color="white"/><Text ml={5}>Add Goal</Text>
            </Button>
          </Tabs.Panel>

          <Tabs.Panel value="Outbrain" pt="xs">
            <Group spacing="xs" mb={5}>
              <Text weight={500}>Ad Account ID:</Text>
              <Select
                data={obAdAccountDetailsData}
                value={obAdAccountDetailsValue}
                onChange={handleobAdAccountDetailsChange}
                name="ob_conv_ad_account_dd"
                w={200}
                ml={28}
              />
            </Group>
            <Group mt={10}>
              <Checkbox
                name="outbrain_conversion_pageview"
                label={<strong>LP visit push as pageview:</strong>}
                checked={outbrainConversionPageview}
                onChange={(event) => handleOutbrainConversionPageviewChange(event)}
              />
              {useObConversionActionMPData ? (
                <Select
                  data={obConversionActionMPData}
                  value={obConvActionValue}
                  onChange={(value) => setObConvActionValue(value)}
                  name="ob_conv_action_resource_name_pageview"
                  w={250}
                />
              ) : (
                <Select
                  data={obConversionActionData}
                  value={obConvActionValue}
                  onChange={(value) => setObConvActionValue(value)}
                  name="ob_conv_action_resource_name_pageview"
                  w={250}
                />
              )}
            </Group>

            {obConvMessageRow.map((group,index) => (
              <Group key={index} mt={10}>
                <Select
                  data={group.ob_conv_action_resource_name.map(action => ({
                    value: action.key,
                    label: action.value
                  }))}
                  name={`ob_conv_action_resource_name[]`}
                  value={getObSelectedValue(group.ob_conv_action_resource_name, 'key')}
                  onChange={(value) => handleObSelectChange(index, 'ob_conv_action_resource_name', value, 'key')}
                  w={250}
                />
                <Select
                  data={group.ob_conv_page_id.map(page => ({
                    value: page.key,
                    label: page.value
                  }))}
                  name={`ob_conv_page_id[]`}
                  value={getObSelectedValue(group.ob_conv_page_id, 'key')}
                  onChange={(value) => handleObSelectChange(index, 'ob_conv_page_id', value, 'key')}
                  w={250}
                />
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removeobGoals(index,'getObValue')}/>
                </ActionIcon>
              </Group>
            ))}

            {obgoalGroups.map(group => (
              <Group key={group.id} mt={10}>
                <Select
                  data={obConversionActionData}
                  value={group.action}
                  onChange={(value) => handleobConversionActionChange(value, group.id)}
                  name={`ob_conv_action_resource_name[]`}
                  w={250}
                />
                <Select
                  data={obConvPageDetailData}
                  value={group.page}
                  onChange={(value) => handleobConvPageDetailChange(value, group.id)}
                  name={`ob_conv_page_id[]`}
                  w={250}
                />
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removeobGoals(group.id,'')}/>
                </ActionIcon>
              </Group>
            ))}
            <Button color="teal" mt={10} onClick={addobGoals}>
              <IconPlus size="1.1rem" color="white"/><Text ml={5}>Add Goal</Text>
            </Button>
          </Tabs.Panel>

          <Tabs.Panel value="LinkedIn" pt="xs">
          <span><strong>Selected LinkedIn Ad Account :</strong> {lnadaccountid}</span>
          {/*<Group mt={10}>
            <Checkbox
              name="linkedin_conversion_pageview"
              label={<strong>LP visit push as pageview:</strong>}
              checked={linkedinConversionPageview}
              onChange={(event) => handleLinkedInConversionPageviewChange(event)}
            />
            {uselnConversionPageviewData ? (
              <Select
                data={lnConvNamePageviewData}
                value={lnConvNameValue}
                onChange={(value) => setLnConvNameValue(value)}
                name="ln_conv_name_pageview"
                w={250}
              />
            ) : (
              <Select
                data={lnConvNamePageviewData}
                value={lnConvNameValue}
                onChange={(value) => setLnConvNameValue(value)}
                name="ln_conv_name_pageview"
                w={250}
              />
            )}
          </Group>*/}
        <Group mt={10}>
        </Group>
          <Text mt={5}>Note: Only conversions sent to Visiopt via webhook can be forwarded to the LinkedIn Conversion API.</Text>
          {Array.isArray(lnConvMessageRow) && lnConvMessageRow.length > 0 && (
            <>
              {lnConvMessageRow.map((group, index) => (
                <Group key={index} mt={10}>
                  <Select
                    data={group.ln_goal_page_id.map(action => ({
                      value: action.key_goal_ln,
                      label: action.value_goal_ln
                    }))}
                    value={getLnSelectedValue(group.ln_goal_page_id, 'key_goal_ln')}
                    onChange={(value) => handleLnSelectChange(index, 'ln_goal_page_id', value, 'key_goal_ln')}
                    name={`ln_goal_page_id[${index}][]`}
                    placeholder="Select Goal"
                    w={250}
                  />
                  <Select
                    data={group.ln_conversion_name.map(action => ({
                      value: action.key_conv_name,
                      label: action.value_conv_name
                    }))}
                    value={getLnSelectedValue(group.ln_conversion_name, 'key_conv_name')}
                    onChange={(value) => handleLnSelectChange(index, 'ln_conversion_name', value, 'key_conv_name')}
                    name={`ln_conversion_name[${index}][]`}
                    w={250}
                  />
                  <ActionIcon title="Remove">
                    <IconCircleMinus size="1.1rem" color="red" onClick={() => removelnGoals(index,'getLnValue')}/>
                  </ActionIcon>
                </Group>
              ))}
            </>
          )}

          {lngoalGroups.map(group => (
            <Group key={group.id} mt={10}>
              <Select
                  data={lnConvPageDetailData}
                  value={group.goal}
                  onChange={(value) => handlelnConversionGoalChange(value, group.id)}
                  name={`ln_conversion_goal[${group.id}][]`}
                  placeholder="Select Goal"
                  w={250}
                />
                <Select
                  data={lnConvNamePageviewData}
                  value={group.name}
                  onChange={(value) => handlelnConversionNameChange(value, group.id)}
                  name={`ln_conversion_name[${group.id}][]`}
                  w={250}
                />
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removelnGoals(group.id,'')}/>
                </ActionIcon> 
            </Group>
          ))}
          <Button color="teal" mt={10} onClick={addlnGoals}>
            <IconPlus size="1.1rem" color="white"/><Text ml={5}>Add Goal</Text>
          </Button>
          </Tabs.Panel>

          <Tabs.Panel value="ChatGPT" pt="md">
            <Text size="sm" mb={12} c="dimmed">Enter the Pixel ID and Conversions API key from the <strong>Conversions</strong> tab of your ChatGPT Ads Manager account (these are different from the Ads connect token).</Text>
            <Group align="flex-end" spacing="md" mb={6}>
              <TextInput
                label="Pixel ID"
                placeholder="Pixel ID"
                value={cgptPixelIdValue}
                onChange={(e:any) => setCgptPixelIdValue(e.target.value)}
                w={260}
              />
              <PasswordInput
                label={cgptHasConversionKey ? 'Conversions API Key (saved)' : 'Conversions API Key'}
                placeholder={cgptHasConversionKey ? 'Enter new key to replace' : 'Conversions API Key'}
                value={cgptConversionKeyValue}
                onChange={(e:any) => setCgptConversionKeyValue(e.target.value)}
                w={260}
              />
              <Button color="teal" loading={cgptCredSaving} onClick={saveChatgptConversionCredentials}>Validate &amp; Save</Button>
              {cgptHasConversionKey && (
                <Group spacing={4} mb={6}>
                  <IconCheck size="1rem" color="green" />
                  <Text size="sm" color="green">Connected</Text>
                </Group>
              )}
            </Group>

            <Divider my="md" />

            <Group mt={10}>
              <Checkbox
                name="chatgpt_conversion_pageview"
                label={<strong>LP visit push as pageview:</strong>}
                checked={chatgptConversionPageview}
                onChange={(event) => handleChatgptConversionPageviewChange(event)}
              />
              <Select
                data={cgptConversionEventMPData}
                value={cgptConversionEventValueMP}
                onChange={(value) => setCgptConversionEventValueMP(value)}
                name="cgpt_conversion_event_pageview"
                w={250}
              />
              {cgptCurrencyEvents.includes(cgptConversionEventValueMP) && (
                <Select
                  data={cgptConversionCurrencyMPData}
                  value={cgptConversionCurrencyValueMP}
                  onChange={(value) => setCgptConversionCurrencyValueMP(value)}
                  name="cgpt_conversion_currency_pageview"
                  w={250}
                />
              )}
            </Group>
            <Text mt={10}>Select the goals you want to pass to ChatGPT. Then select the event to pass for each campaign goal.</Text>

            {Array.isArray(cgptConvMessageRow) && cgptConvMessageRow.length > 0 && (
              <>
                {cgptConvMessageRow.map((group:any, index:number) => (
                  <Group key={index} mt={10}>
                    <MultiSelect
                      data={group.cgpt_conversion_goal.map((action:any) => ({ value: action.key, label: action.value }))}
                      value={getCgptSelectedValue(group.cgpt_conversion_goal, 'key', true)}
                      onChange={(value) => handleCgptSelectChange(index, 'cgpt_conversion_goal', value, 'key', true)}
                      name={`cgpt_conversion_goal[${index}][]`}
                      placeholder="Select Goal"
                      w={250}
                      searchable
                      multiple
                    />
                    <Select
                      data={group.cgpt_conversion_event.map((action:any) => ({ value: action.key, label: action.value }))}
                      value={getCgptSelectedValue(group.cgpt_conversion_event, 'key', false)}
                      onChange={(value) => handleCgptSelectChange(index, 'cgpt_conversion_event', value, 'key', false)}
                      name={`cgpt_conversion_event[${index}][]`}
                      w={250}
                    />
                    {group.cgpt_conversion_currency_row !== 'hide' && (
                      <Select
                        data={group.cgpt_conversion_currency.map((action:any) => ({ value: action.key, label: action.value }))}
                        value={getCgptSelectedValue(group.cgpt_conversion_currency, 'key', false)}
                        onChange={(value) => handleCgptSelectChange(index, 'cgpt_conversion_currency', value, 'key', false)}
                        name={`cgpt_conversion_currency[${index}][]`}
                        w={250}
                      />
                    )}
                    <ActionIcon title="Remove">
                      <IconCircleMinus size="1.1rem" color="red" onClick={() => removecgptGoals(index,'getCgptValue')}/>
                    </ActionIcon>
                  </Group>
                ))}
              </>
            )}

            {cgptgoalGroups.map((group:any) => (
              <Group key={group.id} mt={10}>
                <MultiSelect
                  data={cgptConversionGoalData}
                  value={group.goal}
                  onChange={(value) => handlecgptConversionGoalChange(value, group.id)}
                  name={`cgpt_conversion_goal[${group.id}][]`}
                  placeholder="Select Goal"
                  w={250}
                  searchable
                  multiple
                />
                <Select
                  data={cgptConversionEventData}
                  value={group.event}
                  onChange={(value) => handlecgptConversionEventChange(value, group.id)}
                  name={`cgpt_conversion_event[${group.id}][]`}
                  w={250}
                />
                {cgptCurrencyEvents.includes(group.event) && (
                  <Select
                    data={cgptConversionCurrencyData}
                    value={group.currency}
                    onChange={(value) => handlecgptConversionCurrencyChange(value, group.id)}
                    name={`cgpt_conversion_currency[${group.id}][]`}
                    w={250}
                  />
                )}
                <ActionIcon title="Remove">
                  <IconCircleMinus size="1.1rem" color="red" onClick={() => removecgptGoals(group.id,'')}/>
                </ActionIcon>
              </Group>
            ))}
            <Button color="teal" mt={10} onClick={addcgptGoals}>
              <IconPlus size="1.1rem" color="white"/><Text ml={5}>Add Goal</Text>
            </Button>
          </Tabs.Panel>
        </Tabs>
        <Button mt={20} onClick={handleSaveConversionData}>Save Campaign</Button>
        <Button color="red" mt={20} ml={10} onClick={() => navigate("/manage-campaigns")}>Cancel</Button>
        </Accordion.Panel>
      </Accordion.Item>
      )}
    </>
  );
}